import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import conf from "./../../../config.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import { Modal, Carousel } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import SweetAlert from "sweetalert2-react";
import Select from "react-select";
import ModalPelajari from "./../../partials/ModalPelajari.js";
import ModalDropZoneImage from "../../partials/ModalDropZoneImage";
import { Tab, Tabs } from "react-bootstrap";
import swal from "sweetalert2";
import ExcelImportWizard from "../../partials/ExcelImportWizard";
import DeleteProgressModal from "../../partials/DeleteProgressModal";

import "react-datepicker/dist/react-datepicker.css";
import {
  UserEditSkeleton,
  UserDetailSkeleton,
  UserButtonLoading,
} from "../../partials/loadings/ComponentLoading.js";
import Skeleton from "react-loading-skeleton";

// select style
const selectStyles = {
  control: (styles) => ({
    ...styles,
    borderRadius: "100px",
  }),
};

export default class Guru extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // url api
      url_table: `${conf.uri_backend}api/v1/user/table/GU/`,
      url_count_table: `${conf.uri_backend}api/v1/user/count_table/GU`,
      url_create: `${conf.uri_backend}api/v1/user/create/GU`,
      url_get_user: `${conf.uri_backend}api/v1/user/edit/GU/`,
      url_update: `${conf.uri_backend}api/v1/user/update/GU`,
      url_detail: `${conf.uri_backend}api/v1/user/edit/GU/`,
      url_token_user: `${conf.uri_backend}api/v1/user/update_token/GU`,
      url_generate_all_token: `${conf.uri_backend}api/v1/user/generate-all-token/GU`,
      url_table_token: `${conf.uri_backend}api/v1/user/table_token/GU`,
      url_print_token: `${conf.uri_backend}api/v1/user/generete_token/GU`,
      url_export_data: `${conf.uri_backend}api/v1/user/export/GU/`,
      url_import_data: `${conf.uri_backend}api/v1/user/import/GU`,
      url_save_import_data: `${conf.uri_backend}api/v1/user/import_save/GU/`,
      url_delete: `${conf.uri_backend}api/v1/user/GU/`,
      url_delete_m: `${conf.uri_backend}api/v1/user/user_destroy/GU`,
      url_send_mail: `${conf.uri_backend}api/v1/user/send_mail_activation/GU`,
      url_send_wa: `${conf.uri_backend}api/v1/user/send_wa_activation/GU`,
      url_generate_activation: `${conf.uri_backend}api/v1/user/generate_activation_codes/GU`,
      url_check_username: `${conf.uri_backend}api/v1/user/check-username/GU`,
      url_check_email: `${conf.uri_backend}api/v1/user/check-email/GU`,
      url_check_nik: `${conf.uri_backend}api/v1/user/check-nik/GU`,
      // modal
      modal_tambah: false,
      modal_detail: false,
      modal_cetak: false,
      modal_import: false,
      modal_preview_import: false,
      modal_pelajari: false,
      modal_image: false,
      modal_generate_activation: false,
      modal_excel_wizard: false,

      // var data
      id_generate: "",
      nik: "",
      user_id: "",
      nama: "",
      username: "",
      email: "",
      password: "",
      jenis_kelamin: "",
      tanggal_lahir: "",
      no_telepon: "",
      startDate: new Date(),
      import_file: "",
      tahunSekarang: new Date().getFullYear(),
      showPasswordAdd: false,
      password_create: "",
      // Validation state
      usernameAvailable: null,
      usernameMessage: "",
      usernameRecommendations: [],
      emailAvailable: null,
      emailMessage: "",
      nikAvailable: null,
      nikMessage: "",
      checkingUsername: false,
      checkingEmail: false,
      checkingNik: false,
      usernameCheckTimeout: null,
      emailCheckTimeout: null,
      nikCheckTimeout: null,
      // Password UI state
      showPassword: false,
      passwordStrength: "",
      passwordStrengthText: "",
      // User tracking for edit
      userStatus: "",
      user_id_edit: null,
      // session var
      institusi_id_select: "",
      jenjang_id_select: "",
      npsn_id_select: "",
      data_session: [],
      // gender array
      jenis_kelamin_text: ["Perempuan", "Laki - laki"],
      // for data modal
      data_print: [],
      data_detail: [],
      data_preview: [],
      // alert
      show_alert: false,
      title_alert: "",
      message_alert: "",
      icon_alert: "",
      // search and filter
      searchText: "",
      mode_show: 10,
      query: "",
      simpleLoading: false,
      totalUser: "",
      queryToken: "",
      mode_show_token: 10,
      searchToken: "",
      tombolToken: true,
      isChecked: false,
      check_item: false,
      checkAll: false,
      loading_check: false,
      selectStatus: "",
      loading_generate_token: false,
      loading_mail: false,

      // Generate Activation Code Variables
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto", // "auto" = jumlah saja, "manual" = kode & token diisi sendiri
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }],
      loading_generate_activation: false,
      data_tahun_ajaran: [],
      tahunSekarang: new Date().getFullYear(),

      // Delete Progress Modal state
      modal_delete_progress: false,
      delete_user_id: null,
      delete_user_name: "",
      delete_steps: [],
      delete_current_step: 0,
      delete_error: null,
      is_deleting: false,
      delete_complete: false,
    };

    // Edit Function
    this.update = this.update.bind(this);
    this.showModalEdit = this.showModalEdit.bind(this);
    this.hideModalEdit = this.hideModalEdit.bind(this);

    // Create Funtion
    this.showModalTambah = this.showModalTambah.bind(this);
    this.hideModalTambah = this.hideModalTambah.bind(this);
    this.nama = this.nama.bind(this);
    this.username = this.username.bind(this);
    this.email = this.email.bind(this);
    this.password = this.password.bind(this);
    this.nik = this.nik.bind(this);
    this.jenis_kelamin = this.jenis_kelamin.bind(this);
    this.tanggal_lahir = this.tanggal_lahir.bind(this);
    this.no_telepon = this.no_telepon.bind(this);
    this.create = this.create.bind(this);

    // Delete Function
    this.delete = this.delete.bind(this);

    // Token Function
    this.generate_token = this.generate_token.bind(this);
    this.generateAllToken = this.generateAllToken.bind(this);
    this.id_generate = this.id_generate.bind(this);

    // Detail Function
    this.showModalDetail = this.showModalDetail.bind(this);
    this.hideModalDetail = this.hideModalDetail.bind(this);

    // Cetak Function
    this.showModalCetak = this.showModalCetak.bind(this);
    this.hideModalCetak = this.hideModalCetak.bind(this);
    this.printToken = this.printToken.bind(this);
    this.showTableToken = this.showTableToken.bind(this);

    // Export Function
    this.export = this.export.bind(this);

    // Import Function
    this.showModalImport = this.showModalImport.bind(this);
    this.hideModalImport = this.hideModalImport.bind(this);
    this.import_file = this.import_file.bind(this);
    this.import = this.import.bind(this);

    // Preview Import Function
    this.showModalPrevImport = this.showModalPrevImport.bind(this);
    this.hideModalPrevImport = this.hideModalPrevImport.bind(this);
    this.simpanImport = this.simpanImport.bind(this);

    // Dropzone image
    this.showModalDropzoneImage = this.showModalDropzoneImage.bind(this);
    this.hideModalDropzoneImage = this.hideModalDropzoneImage.bind(this);

    // filter and search
    this.searchText = this.searchText.bind(this);
    this.resetSearch = this.resetSearch.bind(this); // for reset filter

    //Function
    this.showModalPelajari = this.showModalPelajari.bind(this);
    this.hideModalPelajari = this.hideModalPelajari.bind(this);

    this.pilihSemua = this.pilihSemua.bind(this);
    this.showMode = this.showMode.bind(this);
    this.showModeToken = this.showModeToken.bind(this);
    this.showCount = this.showCount.bind(this);

    this.checkAll = this.checkAll.bind(this);
    this.unCheckAll = this.unCheckAll.bind(this);
    this.deleteMulti = this.deleteMulti.bind(this);
    this.sendMailActivation = this.sendMailActivation.bind(this);
    this.sendWAActivation = this.sendWAActivation.bind(this);

    // Generate Activation Code Functions
    this.showModalGenerateActivation = this.showModalGenerateActivation.bind(this);
    this.hideModalGenerateActivation = this.hideModalGenerateActivation.bind(this);
    this.generateActivationCodes = this.generateActivationCodes.bind(this);
    this.activationTahunAjaran = this.activationTahunAjaran.bind(this);
    this.activationPrefix = this.activationPrefix.bind(this);
    this.activationJumlahToken = this.activationJumlahToken.bind(this);
    this.activationTokenSama = this.activationTokenSama.bind(this);
    this.activationSetMode = this.activationSetMode.bind(this);
    this.activationManualChange = this.activationManualChange.bind(this);
    this.activationAddManualRow = this.activationAddManualRow.bind(this);
    this.activationRemoveManualRow = this.activationRemoveManualRow.bind(this);
    this.getTahunAjaranNow = this.getTahunAjaranNow.bind(this);
  }

  componentDidMount() {
    // get session user
    if (localStorage.getItem("token") !== null) {
      axios
        .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.setState({ data_session: res.data }, function () {
            axios
              .get(
                `${conf.uri_backend}api/v1/select-institusi/` +
                this.state.data_session.access_to,
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                this.setState(
                  {
                    institusi_id_select: res.data.id,
                    jenjang_id_select: res.data.m_struktur_jenjang_id,
                    npsn_id_select: res.data.npsn,
                  },
                  function () {
                    this.dt.fetchEntities(
                      `&paginate=${this.state.mode_show}&query=${this.state.query}`
                    );
                    this.showCount();
                  }
                );
              });
          });
        });
    }
    this.getTahunAjaranNow();
  }

  getTahunAjaranNow() {
    var ta = [];
    var u = this.state.tahunSekarang + 1;
    var tahun_sekarang = this.state.tahunSekarang + 1;

    for (var i = tahun_sekarang; i >= 2005; i--) {
      u = u - 1;
      ta.push({ value: u + " / " + i, label: u + " / " + i });
    }
    this.setState({ data_tahun_ajaran: ta });
  }

  showCount() {
    axios
      .get(
        this.state.url_count_table +
        "?institusi=" +
        this.state.institusi_id_select,
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ totalUser: res.data });
      });
  }

  showMode(num) {
    this.setState({ mode_show: num }, function () {
      this.dt.resetPage(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
      this.dt.loading();
    });
  }

  showModeToken(num) {
    this.setState({ mode_show_token: num }, function () {
      this.dtt.resetPage(
        `&paginate=${this.state.mode_show_token}&search=${this.state.searchToken}`
      );
      this.dtt.loading();
      this.setState({ loading_saveprint: false });
    });
  }

  // Bind data
  nama(e) {
    this.setState({ nama: e.target.value });
  }
  username(e) {
    this.setState({ username: e.target.value });
  }
  email(e) {
    this.setState({ email: e.target.value });
  }
  password(e) {
    this.setState({ password: e.target.value });
  }

  nik(e) {
    this.setState({ nik: e.target.value });
  }

  jenis_kelamin(e) {
    this.setState({ jenis_kelamin: e.target.value });
  }

  tanggal_lahir(e) {
    this.setState({
      tanggal_lahir: e.target.value,
      startDate: e.target.value,
    });
  }

  no_telepon(e) {
    this.setState({ no_telepon: e.target.value });
  }

  id_generate(e) {
    this.setState({ id_generate: e.target.value });
  }

  import_file(e) {
    this.setState({ import_file: e.target.files[0] });
  }

  // Create Funtion
  showModalTambah() {
    this.setState({ modal_tambah: true });
  }

  hideModalTambah() {
    this.setState({
      modal_tambah: false,
      nama: "",
      nik: "",
      jenis_kelamin: "",
      tanggal_lahir: "",
      no_telepon: "",
      showPasswordAdd: false,
      password_create: "",
      // Validation state
      url_check_username: `${conf.uri_backend}api/v1/user/check-username/GU`,
      url_check_email: `${conf.uri_backend}api/v1/user/check-email/GU`,
      url_check_nik: `${conf.uri_backend}api/v1/user/check-nik/GU`,
      usernameAvailable: null,
      usernameMessage: "",
      usernameRecommendations: [],
      emailAvailable: null,
      emailMessage: "",
      nikAvailable: null,
      nikMessage: "",
      checkingUsername: false,
      checkingEmail: false,
      checkingNik: false,
    });
  }

  // Validation methods
  checkUsernameAvailability = async (username) => {
    if (!username || username.length < 3) {
      this.setState({ usernameAvailable: null, usernameMessage: "", usernameRecommendations: [], checkingUsername: false });
      return;
    }
    this.setState({ checkingUsername: true });
    try {
      const response = await axios.get(this.state.url_check_username, { params: { username }, withCredentials: true });
      this.setState({
        usernameAvailable: response.data.available,
        usernameMessage: response.data.message,
        usernameRecommendations: response.data.recommendations || [],
        checkingUsername: false
      });
    } catch (error) {
      this.setState({ checkingUsername: false });
    }
  };

  checkEmailAvailability = async (email) => {
    if (!email || email.length < 5) {
      this.setState({ emailAvailable: null, emailMessage: "", checkingEmail: false });
      return;
    }
    this.setState({ checkingEmail: true });
    try {
      const response = await axios.get(this.state.url_check_email, { params: { email }, withCredentials: true });
      this.setState({
        emailAvailable: response.data.available,
        emailMessage: response.data.message,
        checkingEmail: false
      });
    } catch (error) {
      this.setState({ checkingEmail: false });
    }
  };

  checkNikAvailability = async (nik) => {
    if (!nik || nik.length < 3) {
      this.setState({ nikAvailable: null, nikMessage: "", checkingNik: false });
      return;
    }
    this.setState({ checkingNik: true });
    try {
      const response = await axios.get(this.state.url_check_nik, { params: { nik }, withCredentials: true });
      this.setState({
        nikAvailable: response.data.available,
        nikMessage: response.data.message,
        checkingNik: false
      });
    } catch (error) {
      this.setState({ checkingNik: false });
    }
  };

  selectRecommendedUsername = (username) => {
    this.setState({
      username: username,
      usernameAvailable: true,
      usernameMessage: "Username tersedia",
      usernameRecommendations: []
    });
  };

  alertMessage(e) {
    let message = null;

    switch (e.status) {
      case 422:
        message = e.data.messages;
        break;
      case 500:
        message =
          "Ada yang Salah, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 404:
        message = "Url Not Found, Coba Hubungi Admin 😊";
        break;
      case 401:
        message =
          "Nauthorized, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 400:
        message =
          "Koneksi Buruk, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 408:
        message =
          "Request Timeout, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 429:
        message =
          "Too Many Request, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 405:
        message =
          "Method Tidak Diperbolehkan, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
    }

    this.setState({
      show_alert: true,
      title_alert: "Gagal",
      icon_alert: "error",
      message_alert: message,
      simpleLoading: false,
      loading_delete: false,
    });
  }

  create(event) {
    event.preventDefault();

    this.setState({ simpleLoading: true });

    axios.post(
      this.state.url_create,
      {
        username: this.state.username,
        email: this.state.email,
        password: this.state.password,
        nama: this.state.nama,
        kode_pendaftaran: this.state.nik,
        no_handphone: this.state.no_telepon,
        jenis_kelamin: this.state.jenis_kelamin,
        tanggal_lahir: this.state.tanggal_lahir,
        created_at: new Date(),
        user_institusi_id: this.state.institusi_id_select,
        created_by: this.state.institusi_id_select,
        type: "guru",
      },
      { headers: { Authorization: tokenApi } }
    )
      .then((res) => {
        this.setState({
          show_alert: true,
          title_alert: "Berhasil",
          icon_alert: "success",
          message_alert: res.data.messages[0],
          simpleLoading: false,
        });
        this.hideModalTambah();
        this.dt.fetchEntities(
          `&paginate=${this.state.mode_show}&query=${this.state.query}`
        );
        this.dt.loadingCreate();
      })
      .catch((err) => {
        this.alertMessage(err.response);
      });
  }

  // Edit Funtion
  showModalEdit(id) {
    this.setState({
      modal_edit: true,
      loading_edit: true,
      usernameAvailable: null,
      usernameRecommendations: [],
      emailAvailable: null,
      nikAvailable: null,
      passwordStrength: "",
      passwordStrengthText: "",
      password: "",
    });
    axios
      .get(this.state.url_get_user + id, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (res.data.status == true) {
          var data = res.data.data;
          this.setState({
            id_edit: data.id,
            user_id_edit: data.user_id,
            nik: data.kode_pendaftaran,
            nama: data.nama,
            username: data.username,
            email: data.email,
            jenis_kelamin: data.jenis_kelamin,
            tanggal_lahir: data.tanggal_lahir,
            no_telepon: data.no_handphone,
            userStatus: data.status || "",
            loading_edit: false,
          });
        }
      });
  }

  hideModalEdit() {
    // Clear any pending validation timeouts
    if (this.state.usernameCheckTimeout) {
      clearTimeout(this.state.usernameCheckTimeout);
    }
    if (this.state.emailCheckTimeout) {
      clearTimeout(this.state.emailCheckTimeout);
    }
    if (this.state.nikCheckTimeout) {
      clearTimeout(this.state.nikCheckTimeout);
    }
    this.setState({
      modal_edit: false,
      nama: "",
      nik: "",
      jenis_kelamin: "",
      tanggal_lahir: "",
      no_telepon: "",
      password: "",
      userStatus: "",
      user_id_edit: null,
      usernameAvailable: null,
      usernameRecommendations: [],
      emailAvailable: null,
      nikAvailable: null,
      checkingUsername: false,
      checkingEmail: false,
      checkingNik: false,
      passwordStrength: "",
      passwordStrengthText: "",
      showPassword: false,
    });
  }

  // Username availability check with debounce
  checkUsernameAvailability(username) {
    if (this.state.usernameCheckTimeout) {
      clearTimeout(this.state.usernameCheckTimeout);
    }

    if (!username || username.length < 3) {
      this.setState({
        usernameAvailable: null,
        usernameRecommendations: [],
        checkingUsername: false,
      });
      return;
    }

    const timeout = setTimeout(() => {
      this.setState({ checkingUsername: true });

      axios
        .get(this.state.url_check_username, {
          params: {
            username: username,
            exclude_id: this.state.user_id_edit,
          },
          headers: { Authorization: tokenApi },
        })
        .then((res) => {
          this.setState({
            usernameAvailable: res.data.available,
            usernameRecommendations: res.data.recommendations || [],
            checkingUsername: false,
          });
        })
        .catch((err) => {
          console.error("Error checking username:", err);
          this.setState({
            usernameAvailable: null,
            usernameRecommendations: [],
            checkingUsername: false,
          });
        });
    }, 500);

    this.setState({ usernameCheckTimeout: timeout });
  }

  // Email availability check with debounce
  checkEmailAvailability(email) {
    if (this.state.emailCheckTimeout) {
      clearTimeout(this.state.emailCheckTimeout);
    }

    if (!email || email.length < 5) {
      this.setState({
        emailAvailable: null,
        checkingEmail: false,
      });
      return;
    }

    const timeout = setTimeout(() => {
      this.setState({ checkingEmail: true });

      axios
        .get(this.state.url_check_email, {
          params: {
            email: email,
            exclude_id: this.state.user_id_edit,
          },
          headers: { Authorization: tokenApi },
        })
        .then((res) => {
          this.setState({
            emailAvailable: res.data.available,
            checkingEmail: false,
          });
        })
        .catch((err) => {
          console.error("Error checking email:", err);
          this.setState({
            emailAvailable: null,
            checkingEmail: false,
          });
        });
    }, 500);

    this.setState({ emailCheckTimeout: timeout });
  }

  // Select username from recommendations
  selectUsernameRecommendation(recommendation) {
    this.setState({
      username: recommendation,
      usernameAvailable: true,
      usernameRecommendations: [],
    });
  }

  // Toggle password visibility
  togglePasswordVisibility() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }

  // Check password strength
  checkPasswordStrength(password) {
    if (!password) {
      this.setState({ passwordStrength: "", passwordStrengthText: "" });
      return;
    }
    let strength = 0;
    if (password.length >= 8) strength++;
    if (password.match(/[a-z]/) && password.match(/[A-Z]/)) strength++;
    if (password.match(/\d/)) strength++;
    if (password.match(/[^a-zA-Z\d]/)) strength++;

    let text = "";
    let color = "";

    switch (strength) {
      case 0:
      case 1:
        text = "Lemah";
        color = "text-red-500";
        break;
      case 2:
      case 3:
        text = "Sedang";
        color = "text-yellow-500";
        break;
      case 4:
        text = "Kuat";
        color = "text-green-500";
        break;
      default:
        text = "";
    }
    this.setState({ passwordStrength: color, passwordStrengthText: text });
  }

  // NIK/Kode Pendaftaran availability check with debounce
  checkNikAvailability(nik) {
    if (this.state.nikCheckTimeout) {
      clearTimeout(this.state.nikCheckTimeout);
    }

    if (!nik || nik.length < 3) {
      this.setState({
        nikAvailable: null,
        nikMessage: "",
        checkingNik: false,
      });
      return;
    }

    const timeout = setTimeout(() => {
      this.setState({ checkingNik: true });

      axios
        .get(this.state.url_check_nik, {
          params: {
            nik: nik,
            exclude_id: this.state.id_edit,
          },
          headers: { Authorization: tokenApi },
        })
        .then((res) => {
          this.setState({
            nikAvailable: res.data.available,
            nikMessage: res.data.message || "",
            checkingNik: false,
          });
        })
        .catch((err) => {
          console.error("Error checking NIK:", err);
          this.setState({
            nikAvailable: null,
            nikMessage: "",
            checkingNik: false,
          });
        });
    }, 500);

    this.setState({ nikCheckTimeout: timeout });
  }


  update(event) {
    event.preventDefault();

    // Check if username validation is in progress
    if (this.state.checkingUsername) {
      this.setState({
        show_alert: true,
        title_alert: "Mohon Tunggu",
        icon_alert: "warning",
        message_alert: "Sedang memeriksa ketersediaan username. Mohon tunggu sebentar.",
      });
      return;
    }

    // Check if username is not available
    if (this.state.usernameAvailable === false) {
      this.setState({
        show_alert: true,
        title_alert: "Username Tidak Tersedia",
        icon_alert: "error",
        message_alert: "Username yang Anda masukkan sudah digunakan oleh pengguna lain. Silakan pilih username lain dari rekomendasi yang tersedia atau masukkan username yang berbeda.",
      });
      return;
    }

    // Check if NIK validation is in progress
    if (this.state.checkingNik) {
      this.setState({
        show_alert: true,
        title_alert: "Mohon Tunggu",
        icon_alert: "warning",
        message_alert: "Sedang memeriksa ketersediaan No Pendaftaran. Mohon tunggu sebentar.",
      });
      return;
    }

    // Check if NIK is not available
    if (this.state.nikAvailable === false) {
      this.setState({
        show_alert: true,
        title_alert: "No Pendaftaran Tidak Tersedia",
        icon_alert: "error",
        message_alert: this.state.nikMessage || "No Pendaftaran sudah digunakan oleh pengguna lain.",
      });
      return;
    }

    this.setState({ simpleLoading: true });

    if (
      this.state.nama === "" ||
      this.state.nik === "" ||
      this.state.jenis_kelamin === "" ||
      this.state.tanggal_lahir === ""
    ) {
      const missingFields = [];
      if (!this.state.nama) missingFields.push("Nama Lengkap");
      if (!this.state.nik) missingFields.push("No Pendaftaran / NIK");
      if (this.state.jenis_kelamin === "" || this.state.jenis_kelamin === null) missingFields.push("Jenis Kelamin");
      if (!this.state.tanggal_lahir) missingFields.push("Tanggal Lahir");

      this.setState({
        show_alert: true,
        title_alert: "Data Tidak Lengkap",
        icon_alert: "error",
        message_alert: `Mohon lengkapi data berikut: ${missingFields.join(", ")}`,
        simpleLoading: false,
      });
    } else {
      axios
        .post(
          this.state.url_update,
          {
            id: this.state.id_edit,
            nama: this.state.nama,
            email: this.state.email,
            username: this.state.username,
            password: this.state.password,
            kode_pendaftaran: this.state.nik,
            no_handphone: this.state.no_telepon,
            jenis_kelamin: this.state.jenis_kelamin,
            tanggal_lahir: this.state.tanggal_lahir,
            type: "guru",
            updated_by: this.state.institusi_id_select,
          },
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({
            show_alert: true,
            title_alert: "Berhasil",
            icon_alert: "success",
            message_alert: res.data.messages,
            simpleLoading: false,
          });
          this.hideModalEdit();
          this.dt.fetchEntities(
            `&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        })
        .catch((err) => {
          const response = err.response;
          let errorMessage = "Terjadi kesalahan saat menyimpan data. Silakan coba lagi.";

          if (response) {
            switch (response.status) {
              case 422:
                if (response.data.messages && response.data.messages.length > 0) {
                  errorMessage = response.data.messages.join(". ");
                }
                break;
              case 409:
                errorMessage = "Data yang Anda masukkan sudah ada di sistem (duplikat). Silakan periksa kembali username atau email.";
                break;
              case 500:
                errorMessage = "Terjadi kesalahan pada server. Silakan coba beberapa saat lagi atau hubungi administrator.";
                break;
              case 404:
                errorMessage = "Data tidak ditemukan. Mungkin data sudah dihapus oleh pengguna lain.";
                break;
              case 401:
                errorMessage = "Sesi Anda telah berakhir. Silakan login kembali.";
                break;
              case 403:
                errorMessage = "Anda tidak memiliki izin untuk mengubah data ini.";
                break;
            }
          } else if (err.message === 'Network Error') {
            errorMessage = "Tidak dapat terhubung ke server. Silakan periksa koneksi internet Anda.";
          }

          this.setState({
            show_alert: true,
            title_alert: "Gagal Menyimpan",
            icon_alert: "error",
            message_alert: errorMessage,
            simpleLoading: false,
          });
        });
    }
  }

  // Delete Guru - Show progress modal
  delete(data, userName = "User Guru") {
    // Reset delete state and open modal
    this.setState({
      modal_delete_progress: true,
      delete_type: 'single',
      delete_user_id: data,
      delete_user_name: userName,
      delete_steps: [
        { name: "Memeriksa status wali kelas guru", status: "pending" },
        { name: "Menghapus jadwal waktu mengajar", status: "pending" },
        { name: "Menghapus penugasan mata pelajaran", status: "pending" },
        { name: "Menghapus penugasan guru", status: "pending" },
        { name: "Menghapus akun SSO guru", status: "pending" },
        { name: "Menghapus data user guru", status: "pending" },
      ],
      delete_current_step: 0,
      delete_error: null,
      is_deleting: false,
      delete_complete: false,
    });
  }

  // Hide delete progress modal
  hideDeleteProgressModal = () => {
    this.setState({ modal_delete_progress: false });
    // Refresh table if delete was successful
    if (this.state.delete_complete) {
      this.dt.fetchEntities(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
      this.showCount();
    }
  };

  // Execute delete with progress simulation
  executeDelete = () => {
    if (this.state.delete_type === 'multiple') {
      this.setState({ is_deleting: true });
      this.executeBulkDeleteNextBatch(0);
      return;
    }

    this.setState({ is_deleting: true });

    // Simulate progress through steps while actual delete runs
    const simulateProgress = (stepIndex) => {
      if (stepIndex >= this.state.delete_steps.length) return;

      const newSteps = [...this.state.delete_steps];
      newSteps[stepIndex].status = "running";
      this.setState({ delete_steps: newSteps, delete_current_step: stepIndex });
    };

    // Start simulating progress
    let currentStep = 0;
    simulateProgress(currentStep);

    const progressInterval = setInterval(() => {
      currentStep++;
      if (currentStep < this.state.delete_steps.length) {
        // Mark previous as success, current as running
        const newSteps = [...this.state.delete_steps];
        newSteps[currentStep - 1].status = "success";
        newSteps[currentStep].status = "running";
        this.setState({ delete_steps: newSteps, delete_current_step: currentStep });
      }
    }, 400); // Simulate step every 400ms

    // Execute actual delete
    axios
      .delete(this.state.url_delete + this.state.delete_user_id, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        clearInterval(progressInterval);

        // Mark all steps as success
        const newSteps = this.state.delete_steps.map((step) => ({
          ...step,
          status: "success",
        }));

        this.setState({
          delete_steps: newSteps,
          is_deleting: false,
          delete_complete: true,
        });
      })
      .catch((err) => {
        clearInterval(progressInterval);

        // Determine which step failed
        let errorMessage = "Terjadi kesalahan, silakan coba lagi";

        if (err.response && err.response.data) {
          const errorData = err.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.messages) {
            errorMessage = Array.isArray(errorData.messages)
              ? errorData.messages[0]
              : errorData.messages;
          }
        } else if (!err.response) {
          errorMessage = "Periksa koneksi internet anda";
        }

        // Mark current step as error, keep previous as success
        const newSteps = this.state.delete_steps.map((step, index) => ({
          ...step,
          status:
            index < this.state.delete_current_step
              ? "success"
              : index === this.state.delete_current_step
                ? "error"
                : "pending",
        }));

        this.setState({
          delete_steps: newSteps,
          is_deleting: false,
          delete_error: errorMessage,
        });
      });
  };

  // Execute bulk delete next batch sequentially
  executeBulkDeleteNextBatch = (stepIndex) => {
    const { delete_steps } = this.state;
    if (stepIndex >= delete_steps.length) {
      // Completed all batches!
      this.setState({
        is_deleting: false,
        delete_complete: true,
      });
      return;
    }

    // Set current step to running
    const newSteps = [...delete_steps];
    newSteps[stepIndex].status = "running";
    this.setState({ delete_steps: newSteps, delete_current_step: stepIndex });

    // Call bulk delete API for this batch
    const batchIds = delete_steps[stepIndex].ids;
    axios
      .post(
        this.state.url_delete_m,
        { id: batchIds },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        if (res.data.status === false) {
          // Failed!
          const failedSteps = this.state.delete_steps.map((step, idx) => ({
            ...step,
            status: idx < stepIndex ? "success" : idx === stepIndex ? "error" : "pending"
          }));
          this.setState({
            delete_steps: failedSteps,
            is_deleting: false,
            delete_error: (res.data.messages && Array.isArray(res.data.messages)) 
              ? res.data.messages[0] 
              : (res.data.messages || "Gagal menghapus batch data guru"),
          });
        } else {
          // Success for this batch, move to next!
          const successSteps = [...this.state.delete_steps];
          successSteps[stepIndex].status = "success";
          this.setState({ delete_steps: successSteps }, () => {
            this.executeBulkDeleteNextBatch(stepIndex + 1);
          });
        }
      })
      .catch((err) => {
        let errorMessage = "Terjadi kesalahan, silakan coba lagi";
        if (err.response && err.response.data) {
          const errorData = err.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.messages) {
            errorMessage = Array.isArray(errorData.messages)
              ? errorData.messages[0]
              : errorData.messages;
          }
        }
        const failedSteps = this.state.delete_steps.map((step, idx) => ({
          ...step,
          status: idx < stepIndex ? "success" : idx === stepIndex ? "error" : "pending"
        }));
        this.setState({
          delete_steps: failedSteps,
          is_deleting: false,
          delete_error: errorMessage,
        });
      });
  };

  // Retry delete after error
  retryDelete = () => {
    if (this.state.delete_type === 'multiple') {
      const failedStepIndex = this.state.delete_steps.findIndex(
        (step) => step.status === "error" || step.status === "pending"
      );
      const startFrom = failedStepIndex >= 0 ? failedStepIndex : 0;
      
      const resetSteps = this.state.delete_steps.map((step, idx) => ({
        ...step,
        status: idx < startFrom ? "success" : "pending",
      }));

      this.setState(
        {
          delete_steps: resetSteps,
          delete_error: null,
          delete_current_step: startFrom,
          is_deleting: true,
        },
        () => {
          this.executeBulkDeleteNextBatch(startFrom);
        }
      );
      return;
    }

    // Reset steps and try again for single delete
    const newSteps = this.state.delete_steps.map((step) => ({
      ...step,
      status: "pending",
    }));
    this.setState({
      delete_steps: newSteps,
      delete_error: null,
      delete_current_step: 0,
    }, () => {
      this.executeDelete();
    });
  };

  checkAll(e) {
    e.preventDefault();
    this.setState({ loading_check: true }, function () {
      this.setState({ checkAll: true, loading_check: false });
    });
  }

  unCheckAll(e) {
    e.preventDefault();
    this.setState({ loading_check: true }, function () {
      this.setState({ checkAll: false, loading_check: false });
    });
  }

  deleteMulti() {
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_delete: false,
        checkAll: false,
      });
    } else {
      // Chunk size of 10 to prevent timeouts
      const batchSize = 10;
      const total = vals.length;
      const steps = [];
      for (let i = 0; i < total; i += batchSize) {
        const batchNum = Math.floor(i / batchSize) + 1;
        const end = Math.min(i + batchSize, total);
        steps.push({
          name: `Menghapus Batch ${batchNum} (${i + 1} - ${end} dari ${total} guru)`,
          status: "pending",
          ids: vals.slice(i, i + batchSize)
        });
      }

      this.setState({
        modal_delete_progress: true,
        delete_type: 'multiple',
        delete_user_id: null,
        delete_user_ids: vals,
        delete_user_name: `Hapus Massal (${total} Guru)`,
        delete_steps: steps,
        delete_current_step: 0,
        delete_error: null,
        is_deleting: false,
        delete_complete: false,
      });
    }
  }
  sendMailActivation() {
    this.setState({ loading_mail: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    var tokensEmpty = false;

    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
        const tokenElement = document.getElementById("token" + checkboxes[i].value);
        if (tokenElement && tokenElement.innerHTML.trim() === "") {
          tokensEmpty = true;
          break;
        }
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_mail: false,
        checkAll: false,
      });
    } else if (tokensEmpty) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Terdapat user yang belum memiliki token. Harap generate token terlebih dahulu.",
        loading_mail: false,
        checkAll: false,
      });
    } else {
      swal
        .fire({
          title: "Peringatan",
          text: "Apakah anda yakin mengirim email aktivasi user yang dipilih?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Iya`,
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value == true) {
            axios
              .post(
                this.state.url_send_mail,
                { id: vals },
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                if (res.data.status == false) {
                  this.setState({
                    show_alert: true,
                    title_alert: "Gagal",
                    icon_alert: "error",
                    message_alert:
                      res.data.messages[0] +
                      "Berhasil : " +
                      res.data.berhasil +
                      "Gagal : " +
                      res.data.gagal,
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                } else {
                  this.setState({
                    show_alert: true,
                    title_alert: "Berhasil",
                    icon_alert: "success",
                    message_alert: res.data.messages[0],
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                }
              })
              .catch((err) => {
                this.setState({ loading_mail: false });
                // this.alertMessage(err.response);
              });
          } else if (result.dismiss == "cancel") {
            this.setState({ loading_mail: false });
          } else if (result.dismiss == "backdrop") {
            this.setState({ loading_mail: false });
          }
        });
    }
  }

  sendWAActivation() {
    this.setState({ loading_mail: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    var tokensEmpty = false;

    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
        const tokenElement = document.getElementById("token" + checkboxes[i].value);
        if (tokenElement && tokenElement.innerHTML.trim() === "") {
          tokensEmpty = true;
          break;
        }
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_mail: false,
        checkAll: false,
      });
    } else if (tokensEmpty) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Terdapat user yang belum memiliki token. Harap generate token terlebih dahulu.",
        loading_mail: false,
        checkAll: false,
      });
    } else {
      swal
        .fire({
          title: "Peringatan",
          text: "Apakah anda yakin mengirim email aktivasi user yang dipilih?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Iya`,
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value == true) {
            axios
              .post(
                this.state.url_send_wa,
                { id: vals },
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                if (res.data.status == false) {
                  this.setState({
                    show_alert: true,
                    title_alert: "Gagal",
                    icon_alert: "error",
                    message_alert:
                      res.data.messages[0] +
                      "Berhasil : " +
                      res.data.berhasil +
                      "Gagal : " +
                      res.data.gagal,
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                } else {
                  this.setState({
                    show_alert: true,
                    title_alert: "Berhasil",
                    icon_alert: "success",
                    message_alert: res.data.messages[0],
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                }
              })
              .catch((err) => {
                this.setState({ loading_mail: false });
                // this.alertMessage(err.response);
              });
          } else if (result.dismiss == "cancel") {
            this.setState({ loading_mail: false });
          } else if (result.dismiss == "backdrop") {
            this.setState({ loading_mail: false });
          }
        });
    }
  }

  // Modal Detail
  showModalDetail(data) {
    this.setState({
      modal_detail: true,
      loading_detail: true,
    });
    axios
      .get(this.state.url_detail + data, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        this.setState({
          data_detail: res.data.data,
          loading_detail: false,
        });
      });
  }

  hideModalDetail() {
    this.setState({
      data_detail: "",
      modal_detail: false,
    });
  }

  // Cetak Function
  showModalCetak() {
    this.setState(
      {
        modal_cetak: true,
        queryToken: `&paginate=10&search=`,
      },
      function () {
        this.dtt.fetchEntities(this.state.queryToken);
      }
    );
    // axios.get(`${this.state.url_table_token}/${this.state.institusi_id_select}?paginate=10`, {headers:{Authorization:tokenApi}}).then(res => {
    //   this.setState({ data_print: res.data, loading_print: false });
    // });
  }

  showTableToken() {
    if (this.state.queryToken != "") {
      return (
        <div>
          <DataTable
            ref={(dtt) => {
              this.dtt = dtt;
            }}
            action={{
              jenis_kelamin: (col, data) => {
                var jekel = "";
                if (col.jenis_kelamin == 1) {
                  jekel = "Laki - Laki";
                }

                if (col.jenis_kelamin == 0) {
                  jekel = "Perempuan";
                }

                if (col.jenis_kelamin == null) {
                  jekel = "Belum diketahui";
                }
                return <p className="text-sm">{jekel}</p>;
              },
              pilih: (col, data) => {
                return (
                  <input
                    type="checkbox"
                    name="check_data[]"
                    className="check"
                    id="check_data"
                    value={data.id}
                    defaultChecked={this.state.PilihSemua ? true : false}
                  />
                );
              },
            }}
            url={
              this.state.url_table_token + "/" + this.state.institusi_id_select
            }
            columns={[
              {
                index: "kode_pendaftaran",
                label: "Kode Pendaftaran",
              },
              {
                index: "token",
                label: "token",
              },
              {
                index: "nama",
                label: "nama",
              },
              {
                index: "jenis_kelamin",
                label: "Jenis Kelamin",
              },
              {
                index: "pilih",
                label: "pilih",
              },
            ]}
          />
        </div>
      );
    }
  }

  hideModalCetak() {
    this.setState({
      modal_cetak: false,
      queryToken: "",
      pilihSemua: false,
      searchToken: "",
      mode_show_token: 10,
    });
  }

  printToken(e) {
    e.preventDefault();
    this.setState({ loading_saveprint: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = "";
    var str = "";
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals += "," + checkboxes[i].value;
        str = vals.substr(1);
      }
    }

    if (str == "") {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "error",
        message_alert: "Pilih atau centang User terlebih dahulu",
        loading_saveprint: false,
      });
    } else {
      axios
        .post(
          this.state.url_print_token,
          { id: str },
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({ loading_saveprint: false });
          var mywindow = window.open("", "new div", "height=400,width=600");
          var jekel = ["Perempuan", "Laki - Laki"];
          res.data.map((person, index) => {
            mywindow.document.write(
              `<html>
              <head>
              </head>
              <body style="display: flex; flex-wrap: wrap; align-content: flex-start;">
                <table style="width:48%; margin-bottom:10px; margin-left: 10px; border-radius: 8px; padding: 4px;" border="1px solid #000000">
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">KODE PENDAFTARAN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.kode_pendaftaran
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">TOKEN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.token
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">NAMA</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.nama
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">JENIS KELAMIN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${jekel[person.jenis_kelamin]
              }</td>
                  </tr>
                </table>
              </body>
            </html>`
            );
          });
          mywindow.print();
          mywindow.close();
        })
        .catch((err) => {
          this.alertMessage(err.response);
          this.setState({ loading_saveprint: false });
        });
    }
  }
  // Generate All Token
  generateAllToken() {
    this.setState({ loading_generate_token: true });
    this.setState({ loading_token: true });
    axios
      .post(
        this.state.url_generate_all_token,
        { user_institusi_id: this.state.institusi_id_select },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ loading_generate_token: false });
        this.setState({ loading_token: false });
        if (res.data.status === true) {
          this.dt.loading();
          this.dt.resetPage(
            `&status=${this.state.selectStatus}&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        } else {
          swal.fire({
            title: "Gagal",
            text: "Ada Kesalahan",
            icon: "error",
          });
        }
        this.setState({ loading_token: false });
      });
  }

  // Generate Token
  generate_token(data) {
    this.setState({ loading_token: data });
    axios
      .post(
        this.state.url_token_user,
        { user_id: data },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        if (res.data.status === true) {
          document.getElementById("token" + data + "").innerHTML ==
            "" + res.data.token + "";
          var elementText = document.getElementById("token" + data + "");
          elementText.classList.add("block");
          var elementButton = document.getElementById("myButton" + data + "");
          elementButton.classList.remove("block");
        }
        this.setState({ loading_token: false });
      });
  }

  // reset search
  resetSearch(event) {
    event.preventDefault();
    document.getElementById("search").value = "";
    this.dt.fetchEntities(
      `&paginate=${this.state.mode_show}&query=${this.state.query}`
    );
  }

  export(event) {
    event.preventDefault();
    this.setState({ loading_export: true });
    axios({
      url: this.state.url_export_data + this.state.institusi_id_select,
      method: "POST",
      responseType: "blob", // important
      headers: { Authorization: tokenApi },
      data: {
        status: this.state.selectStatus,
      },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        var tanggal = new Date();
        var bulan = tanggal.getMonth() + 1;
        if (bulan < 10 ? (bulan = `0${bulan}`) : "");
        link.setAttribute(
          "download",
          "Guru_" +
          tanggal.getDate() +
          "-" +
          bulan +
          "-" +
          tanggal.getFullYear() +
          "_TIME(" +
          tanggal.getHours() +
          "-" +
          tanggal.getMinutes() +
          ").xlsx"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        this.setState({ loading_export: false });
      })
      .catch((err) => {
        this.setState({ loading_export: false });
        this.alertMessage(err);
      });
  }

  // Modal import
  showModalImport() {
    this.setState({ modal_import: true });
  }

  hideModalImport() {
    this.setState({ modal_import: false });
  }

  import(event) {
    event.preventDefault();

    this.setState({ simpleLoading: true });

    const data = new FormData();
    data.append("file", this.state.import_file);

    axios
      .post(this.state.url_import_data, data, {
        headers: { Authorization: `Bearer ${tokenApi}` }, // Pastikan tokenApi valid
      })
      .then((res) => {
        if (res.data.status === false) {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.messages?.[0] || "Terjadi kesalahan", // Handle jika messages undefined
            simpleLoading: false, // Berhentikan loading di sini
          });
        } else {
          this.showModalPrevImport(res.data.data);
          this.hideModalImport();
          this.setState({ simpleLoading: false }); // Pastikan loading diatur ulang
        }
      })
      .catch((err) => {
        const statusCode = err.response?.status || 0; // Status HTTP error (misal: 400, 500)
        const errorMessage =
          err.response?.data?.messages?.[0] || // Pesan dari API jika ada
          err.response?.data?.message || // Pesan fallback lain dari API
          "Terjadi kesalahan"; // Pesan default jika tidak ada info

        this.setState({
          show_alert: true,
          title_alert: `Error ${statusCode}`, // Tambahkan kode status untuk debugging
          icon_alert: "error",
          message_alert: errorMessage,
          simpleLoading: false,
        });

        console.error("Error XHR Response:", {
          status: statusCode,
          data: err.response?.data, // Log seluruh data respons error
        });
      });
  }


  // Modal Import Detail
  showModalPrevImport(data) {
    this.setState({
      data_preview: data,
      simpleLoading: false,
      modal_preview_import: true,
    });
  }

  hideModalPrevImport() {
    this.setState({ modal_preview_import: false });
  }

  simpanImport(e) {
    e.preventDefault();
    this.setState({ simpleLoading: true });
    axios
      .post(
        this.state.url_save_import_data + this.state.institusi_id_select,
        { data: this.state.data_preview },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        if (res.data.status == false) {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
        } else {
          this.setState({
            show_alert: true,
            title_alert: res.data.title[0],
            icon_alert: res.data.icon[0],
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
          this.hideModalPrevImport();
          this.dt.fetchEntities(
            `&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        }
      })
      .catch((err) => {
        this.setState({ simpleLoading: false });
        this.alertMessage(err.response);
      });
  }

  searchText(e) {
    e.preventDefault();

    this.setState({ query: e.target.value }, function () {
      this.dt.loading();
      this.dt.resetPage(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
    });
  }

  showModalPelajari() {
    this.setState({ modal_pelajari: true });
  }
  hideModalPelajari() {
    this.setState({ modal_pelajari: false });
  }

  changeStatus = (e) => {
    if (e) {
      this.setState(
        {
          selectStatus: e.value,
        },
        function () {
          this.dt.loading();
          this.dt.resetPage(
            `&status=${this.state.selectStatus}&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        }
      );
    } else {
      this.dt.loading();
      this.dt.resetPage(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
    }
  };

  pilihSemua() {
    var checkboxes = document.getElementsByClassName("select-all").item(0)
      .checked;
    if (checkboxes == true) {
      this.setState({ PilihSemua: true }, function () {
        this.dtt.loading();
        this.dtt.fetchEntities(this.state.queryToken);
      });
    } else {
      this.setState({ PilihSemua: false }, function () {
        this.dtt.loading();
        this.dtt.fetchEntities(this.state.queryToken);
      });
    }
  }

  // Menampilkan modal dropzone foto profil
  showModalDropzoneImage() {
    this.setState({ modal_image: true });
  }

  // Tutup modal dropzone foto profil
  hideModalDropzoneImage() {
    this.setState({ modal_image: false });
  }

  // Generate Activation Code Modal Functions
  showModalGenerateActivation() {
    this.setState({
      modal_generate_activation: true,
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto",
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }]
    });
  }

  hideModalGenerateActivation() {
    this.setState({
      modal_generate_activation: false,
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto",
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }]
    });
  }

  activationTahunAjaran(e) {
    this.setState({ activation_tahun_ajaran: e.value });
  }

  activationPrefix(e) {
    this.setState({ activation_prefix: e.target.value });
  }

  activationJumlahToken(e) {
    this.setState({ activation_jumlah_token: e.target.value });
  }

  activationTokenSama(e) {
    this.setState({ activation_token_sama: e.target.checked });
  }

  // Ganti mode antara "auto" (jumlah saja) dan "manual" (isi kode & token sendiri)
  activationSetMode(mode) {
    this.setState({
      activation_mode: mode,
      activation_manual_list:
        mode === "manual" && this.state.activation_manual_list.length === 0
          ? [{ kode_pendaftaran: "", token: "" }]
          : this.state.activation_manual_list
    });
  }

  // Ubah nilai kode_pendaftaran / token pada baris manual tertentu
  activationManualChange(index, field, value) {
    const list = [...this.state.activation_manual_list];
    list[index] = { ...list[index], [field]: value };
    this.setState({ activation_manual_list: list });
  }

  // Tambah baris input manual baru
  activationAddManualRow() {
    this.setState({
      activation_manual_list: [
        ...this.state.activation_manual_list,
        { kode_pendaftaran: "", token: "" }
      ]
    });
  }

  // Hapus baris input manual
  activationRemoveManualRow(index) {
    const list = [...this.state.activation_manual_list];
    if (list.length <= 1) return; // minimal 1 baris
    list.splice(index, 1);
    this.setState({ activation_manual_list: list });
  }

  generateActivationCodes(e) {
    e.preventDefault();

    const isManual = this.state.activation_mode === "manual";

    let jumlah_token;
    let kode_pendaftaran_arr = [];
    let token_arr = [];

    if (isManual) {
      // Validasi mode manual: setiap baris wajib punya kode_pendaftaran & token
      const list = this.state.activation_manual_list;
      const invalid = list.some(
        (row) => !row.kode_pendaftaran || !row.token
      );

      if (list.length === 0 || invalid) {
        this.setState({
          show_alert: true,
          title_alert: "Validasi",
          icon_alert: "warning",
          message_alert: "Kode pendaftaran dan token wajib diisi untuk setiap baris!"
        });
        return;
      }

      jumlah_token = list.length;
      kode_pendaftaran_arr = list.map((row) => row.kode_pendaftaran);
      token_arr = list.map((row) => row.token);
    } else {
      if (!this.state.activation_jumlah_token || this.state.activation_jumlah_token <= 0) {
        this.setState({
          show_alert: true,
          title_alert: "Validasi",
          icon_alert: "warning",
          message_alert: "Jumlah token harus diisi dan lebih dari 0!"
        });
        return;
      }
      jumlah_token = parseInt(this.state.activation_jumlah_token);
    }

    this.setState({ loading_generate_activation: true });

    const data = {
      user_institusi_id: this.state.institusi_id_select,
      // tahun_ajaran: this.state.activation_tahun_ajaran,
      prefix: this.state.activation_prefix || "",
      jumlah_token: jumlah_token,
      token_sama: isManual ? false : this.state.activation_token_sama
    };

    if (isManual) {
      data.kode_pendaftaran = kode_pendaftaran_arr;
      data.token = token_arr;
    }

    axios
      .post(this.state.url_generate_activation, data, {
        headers: { Authorization: tokenApi }
      })
      .then((res) => {
        this.setState({ loading_generate_activation: false });
        if (res.data.status) {
          const totalCreated = res.data.data?.total_created ?? 0;
          const totalFailed = res.data.data?.total_failed ?? 0;
          const failedList = res.data.data?.failed ?? [];

          if (totalCreated === 0) {
            // Tidak ada satupun token yang berhasil dibuat (mis. kode/token
            // sudah dipakai) -> jangan tampilkan sebagai berhasil
            const friendlyReason = (reason) => {
              if (!reason) return "gagal dibuat";
              if (reason.toLowerCase().includes("sudah dipakai")) return "sudah pernah digunakan";
              if (reason.toLowerCase().includes("sudah ada setelah")) return "gagal dibuat karena bentrok dengan kode lain";
              return reason;
            };
            const failReasons = failedList
              .map((f) => `Kode ${f.kode_pendaftaran} ${friendlyReason(f.reason)}`)
              .join(", ");
            this.setState({
              show_alert: true,
              title_alert: "Gagal",
              icon_alert: "error",
              message_alert: failReasons
                ? `${failReasons}.`
                : res.data.message
            });
            return;
          }

          if (totalFailed > 0) {
            // Sebagian berhasil, sebagian gagal
            this.setState({
              show_alert: true,
              title_alert: "Sebagian Berhasil",
              icon_alert: "warning",
              message_alert: res.data.message,
              modal_generate_activation: false
            });
          } else {
            this.setState({
              show_alert: true,
              title_alert: "Berhasil",
              icon_alert: "success",
              message_alert: res.data.message,
              modal_generate_activation: false
            });
          }
          // Refresh data table
          this.dt.loading();
          this.dt.resetPage();
        } else {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.message || "Gagal membuat kode aktivasi"
          });
        }
      })
      .catch((err) => {
        this.setState({ loading_generate_activation: false });
        let errorMessage = "Terjadi kesalahan sistem";
        if (err.response && err.response.data && err.response.data.messages) {
          errorMessage = Array.isArray(err.response.data.messages)
            ? err.response.data.messages.join(", ")
            : err.response.data.messages;
        }
        this.setState({
          show_alert: true,
          title_alert: "Error",
          icon_alert: "error",
          message_alert: errorMessage
        });
      });
  }

  render() {
    // let modalPelajari=this.props.modal_pelajari
    return (
      <div>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-6 mt-6 sm-container">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
            <div>
              <div className="flex items-center gap-2">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 text-blue-600">
                  <i className="bx bxs-user text-xl"></i>
                </span>
                <h1 className="text-xl font-bold text-gray-900">
                  Manajemen Guru
                </h1>
              </div>
              <p className="text-gray-500 text-sm mt-1">
                Kelola data akun guru, buat token, export data, dan atur kode aktivasi.
              </p>
            </div>
            <div className="flex flex-wrap gap-2 items-center">
              {this.state.institusi_id_select != "" ? (
                <>
                  <button
                    onClick={this.generateAllToken}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                    disabled={this.state.loading_generate_token ? true : false}
                  >
                    {this.state.loading_generate_token ? (
                      <UserButtonLoading color="text-gray-700" />
                    ) : (
                      <>
                        <i className="bx bx-doughnut-chart text-lg"></i>{" "}
                        Generate Token
                      </>
                    )}
                  </button>
                  <button
                    onClick={this.showModalGenerateActivation}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-key text-lg"></i> Generate Activation
                  </button>
                  <button
                    onClick={this.export}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                    disabled={this.state.loading_export ? true : false}
                  >
                    {this.state.loading_export ? (
                      <UserButtonLoading color="text-gray-700" />
                    ) : (
                      <>
                        <i className="bx bx-export text-lg"></i> Export
                      </>
                    )}
                  </button>
                  <button
                    onClick={() => this.setState({ modal_excel_wizard: true })}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-upload text-lg"></i> Upload
                  </button>
                  <button
                    onClick={this.showModalCetak}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-printer text-lg"></i> Cetak
                  </button>
                  <button
                    className="flex items-center justify-center gap-1.5 px-5 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-all duration-200 shadow-md shadow-blue-500/10 active:scale-95"
                    onClick={this.showModalTambah}
                  >
                    <i className="bx bx-plus text-lg"></i>
                    Tambah
                  </button>
                  <button
                    onClick={this.showModalDropzoneImage}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-upload text-lg"></i> Foto Profil
                  </button>
                </>
              ) : (
                <>
                  <div className="w-20 px-2">
                    {" "}
                    <Skeleton height={20} className="bg-gray-400" />{" "}
                  </div>
                  <div className="w-20 px-2">
                    {" "}
                    <Skeleton height={20} className="bg-gray-400" />{" "}
                  </div>
                  <div className="w-20 px-2">
                    {" "}
                    <Skeleton height={20} className="bg-gray-400" />{" "}
                  </div>
                  <div className="w-20 px-2">
                    {" "}
                    <Skeleton height={20} className="bg-gray-400" />{" "}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* alert */}
        <SweetAlert
          show={this.state.show_alert}
          title={this.state.title_alert}
          text={this.state.message_alert}
          type={this.state.icon_alert}
          onConfirm={() => this.setState({ show_alert: false })}
          onOutsideClick={() => this.setState({ show_alert: false })}
        />

        {/* Modal dropzone foto profil */}
        <ModalDropZoneImage showModal={this.state.modal_image} hideModal={this.hideModalDropzoneImage} type="GU" />

        {/* Modal Generate Activation */}
        <Modal show={this.state.modal_generate_activation} onHide={this.hideModalGenerateActivation}>
          <Modal.Header>Generate Kode Aktivasi</Modal.Header>
          <Modal.Body>
            {/* Toggle Mode: Otomatis vs Manual */}
            <div className="w-full flex gap-2 mb-2">
              <button
                type="button"
                onClick={() => this.activationSetMode("auto")}
                className={
                  this.state.activation_mode === "auto"
                    ? "flex-1 px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-full"
                    : "flex-1 px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 rounded-full"
                }
              >
                Otomatis
              </button>
              <button
                type="button"
                onClick={() => this.activationSetMode("manual")}
                className={
                  this.state.activation_mode === "manual"
                    ? "flex-1 px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-full"
                    : "flex-1 px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 rounded-full"
                }
              >
                Manual
              </button>
            </div>

            <form onSubmit={this.generateActivationCodes}>
              {/* <div className="w-full mt-3">
                <label className="mb-2 ml-2 text-gray-800 block text-sm mt-3">
                  Tahun Ajaran <span className="text-red-500">*</span>
                </label>
                <Select
                  styles={selectStyles}
                  className="react-select__control w-100"
                  placeholder="Pilih Tahun Ajaran"
                  options={this.state.data_tahun_ajaran}
                  onChange={this.activationTahunAjaran}
                />
              </div> */}

              {this.state.activation_mode === "auto" ? (
                <>
                  <div className="w-full mt-3">
                    <label className="mb-2 ml-2 text-gray-800 block text-sm mt-3">
                      Prefix (Opsional)
                    </label>
                    <input
                      type="text"
                      className="w-full pl-4 pr-4 my-0 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800"
                      placeholder="Masukkan prefix untuk token (contoh: GU)"
                      onChange={this.activationPrefix}
                      value={this.state.activation_prefix}
                    />
                  </div>
                  <div className="w-full mt-3">
                    <label className="mb-2 ml-2 text-gray-800 block text-sm mt-3">
                      Jumlah Token <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      className="w-full pl-4 pr-4 my-0 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800"
                      placeholder="Masukkan jumlah token yang akan digenerate"
                      onChange={this.activationJumlahToken}
                      value={this.state.activation_jumlah_token}
                    />
                  </div>
                  {/* <div className="w-full mt-3">
                    <label className="inline-flex items-center align-middle ml-2">
                      <input
                        type="checkbox"
                        className="form-checkbox"
                        onChange={this.activationTokenSama}
                        checked={this.state.activation_token_sama}
                      />
                      <span className="ml-2 text-gray-800 block text-sm">
                        Generate token yang sama untuk semua user
                      </span>
                    </label>
                  </div> */}
                </>
              ) : (
                <div className="w-full mt-3">
                  <label className="mb-2 ml-2 text-gray-800 block text-sm">
                    Kode Pendaftaran &amp; Token <span className="text-red-500">*</span>
                  </label>
                  <div className="max-h-64 overflow-y-auto pr-1">
                    {this.state.activation_manual_list.map((row, index) => (
                      <div key={index} className="flex gap-2 items-center mb-2">
                        <input
                          type="text"
                          className="w-1/2 pl-4 pr-4 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm"
                          placeholder="Kode Pendaftaran"
                          value={row.kode_pendaftaran}
                          onChange={(e) =>
                            this.activationManualChange(index, "kode_pendaftaran", e.target.value)
                          }
                        />
                        <input
                          type="text"
                          className="w-1/2 pl-4 pr-4 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm"
                          placeholder="Token"
                          value={row.token}
                          onChange={(e) =>
                            this.activationManualChange(index, "token", e.target.value)
                          }
                        />
                        <button
                          type="button"
                          onClick={() => this.activationRemoveManualRow(index)}
                          className="btn-red text-white w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full"
                          disabled={this.state.activation_manual_list.length <= 1}
                        >
                          <i className="bx bx-trash"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={this.activationAddManualRow}
                    className="btn-default flex items-center gap-1 px-4 py-2 text-sm rounded-full mt-1"
                  >
                    <i className="bx bx-plus"></i> Tambah Baris
                  </button>
                  <p className="text-xs text-gray-500 ml-2 mt-2">
                    Jumlah token yang akan dibuat: {this.state.activation_manual_list.length}
                  </p>
                </div>
              )}

              <input
                type="submit"
                className={
                  this.state.loading_generate_activation
                    ? "btn-disabled px-4 flex items-center rounded-full py-2 mt-3 text-sm"
                    : "btn-schoolmedia px-4 flex items-center rounded-full text-white py-2 mt-3 text-sm"
                }
                value={this.state.loading_generate_activation ? "Tunggu..." : "Generate"}
                disabled={this.state.loading_generate_activation ? true : false}
              />
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalGenerateActivation}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* modal pelajari */}
        <ModalPelajari showModalPelajari={this.showModalPelajari} />

        <Modal show={this.state.modal_pelajari} className="modal-pelajari">
          <Modal.Body>
            <Carousel autoPlay={false} interval={null}>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://static.schoolmedia.id/public/assets/um/sample/langkah-1.svg"
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://static.schoolmedia.id/public/assets/um/sample/langkah-2.svg"
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://static.schoolmedia.id/public/assets/um/sample/langkah-3.svg"
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://static.schoolmedia.id/public/assets/um/sample/langkah-4.svg"
                  alt="Third slide"
                />
              </Carousel.Item>
            </Carousel>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalPelajari}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* modal tambah - Premium Design */}
        <Modal
          show={this.state.modal_tambah}
          onHide={this.hideModalTambah}
          dialogClassName="modal-lg"
        >
          <div className="bg-white">
            {/* Premium Gradient Header */}
            <div className="modal-header-gradient-blue-purple px-6 py-5">
              <div className="flex items-center">
                <div className="w-12 h-12 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center mr-4">
                  <i className="bx bxs-user-plus text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">Tambah Guru Baru</h3>
                  <p className="text-blue-100 text-sm">Isi data guru dengan lengkap</p>
                </div>
              </div>
              <button
                onClick={this.hideModalTambah}
                className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
              >
                <i className="bx bx-x text-2xl"></i>
              </button>
            </div>

            {/* Form Body */}
            <form onSubmit={this.create}>
              <div className="p-6">
                {/* Grid Layout - 2 Columns */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                  {/* Left Column - Data Pribadi */}
                  <div className="space-y-4">
                    <div className="flex items-center mb-4">
                      <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center mr-3">
                        <i className="bx bx-user text-blue-600"></i>
                      </div>
                      <h4 className="font-semibold text-gray-800">Data Pribadi</h4>
                    </div>

                    {/* No Pendaftaran */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        No Pendaftaran (NIK/NIP/KK/No Pegawai)
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <i className="bx bx-id-card"></i>
                        </span>
                        <input
                          type="text"
                          className={`w-full pl-10 pr-10 py-2.5 rounded-xl border transition-all text-gray-800 ${this.state.nikAvailable === false ? 'border-red-400 focus:border-red-500 focus:ring-red-100' :
                            this.state.nikAvailable === true ? 'border-green-400 focus:border-green-500 focus:ring-green-100' :
                              'border-gray-200 focus:border-blue-500 focus:ring-blue-100'
                            } focus:ring-2`}
                          placeholder="Masukkan No Pendaftaran"
                          onChange={(e) => {
                            this.nik(e);
                            const value = e.target.value;
                            clearTimeout(this.nikTimeout);
                            this.nikTimeout = setTimeout(() => this.checkNikAvailability(value), 500);
                          }}
                        />
                        {this.state.checkingNik && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2">
                            <i className="bx bx-loader-alt animate-spin text-gray-400"></i>
                          </span>
                        )}
                        {!this.state.checkingNik && this.state.nikAvailable === true && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-green-500">
                            <i className="bx bx-check-circle"></i>
                          </span>
                        )}
                        {!this.state.checkingNik && this.state.nikAvailable === false && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500">
                            <i className="bx bx-x-circle"></i>
                          </span>
                        )}
                      </div>
                      {this.state.nikMessage && (
                        <p className={`text-xs mt-1 ${this.state.nikAvailable ? 'text-green-600' : 'text-red-600'}`}>
                          {this.state.nikMessage}
                        </p>
                      )}
                    </div>

                    {/* Nama */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Nama Lengkap <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <i className="bx bx-user-circle"></i>
                        </span>
                        <input
                          type="text"
                          className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all text-gray-800"
                          placeholder="Masukkan Nama Lengkap"
                          onChange={this.nama}
                        />
                      </div>
                    </div>

                    {/* Jenis Kelamin */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Jenis Kelamin <span className="text-red-500">*</span>
                      </label>
                      <div className="flex space-x-4">
                        <label className="flex items-center px-4 py-2.5 rounded-xl border border-gray-200 hover:border-blue-400 cursor-pointer transition-all">
                          <input
                            type="radio"
                            className="form-radio text-blue-600"
                            value="1"
                            name="jenis_kelamin"
                            onChange={this.jenis_kelamin}
                          />
                          <span className="ml-2 text-gray-700 text-sm">Laki-laki</span>
                        </label>
                        <label className="flex items-center px-4 py-2.5 rounded-xl border border-gray-200 hover:border-blue-400 cursor-pointer transition-all">
                          <input
                            type="radio"
                            className="form-radio text-blue-600"
                            value="0"
                            name="jenis_kelamin"
                            onChange={this.jenis_kelamin}
                          />
                          <span className="ml-2 text-gray-700 text-sm">Perempuan</span>
                        </label>
                      </div>
                    </div>

                    {/* Tanggal Lahir */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Tanggal Lahir
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <i className="bx bx-calendar"></i>
                        </span>
                        <input
                          type="date"
                          className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all text-gray-800"
                          onChange={this.tanggal_lahir}
                        />
                      </div>
                    </div>

                    {/* No Telepon */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        No Telepon <span className="text-gray-400 text-xs">(Opsional)</span>
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <i className="bx bx-phone"></i>
                        </span>
                        <input
                          type="number"
                          min="0"
                          className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all text-gray-800"
                          placeholder="Masukkan No Telepon"
                          onChange={this.no_telepon}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right Column - Akun Login */}
                  <div className="space-y-4">
                    <div className="flex items-center mb-4">
                      <div className="w-8 h-8 rounded-lg bg-indigo-50 flex items-center justify-center mr-3">
                        <i className="bx bx-lock-alt text-indigo-600"></i>
                      </div>
                      <h4 className="font-semibold text-gray-800">Akun Login</h4>
                    </div>

                    {/* Username */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Username <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <i className="bx bx-at"></i>
                        </span>
                        <input
                          type="text"
                          className={`w-full pl-10 pr-10 py-2.5 rounded-xl border transition-all text-gray-800 ${this.state.usernameAvailable === false ? 'border-red-400 focus:border-red-500 focus:ring-red-100' :
                            this.state.usernameAvailable === true ? 'border-green-400 focus:border-green-500 focus:ring-green-100' :
                              'border-gray-200 focus:border-blue-500 focus:ring-blue-100'
                            } focus:ring-2`}
                          placeholder="Masukkan Username"
                          value={this.state.username}
                          onChange={(e) => {
                            this.username(e);
                            const value = e.target.value;
                            clearTimeout(this.usernameTimeout);
                            this.usernameTimeout = setTimeout(() => this.checkUsernameAvailability(value), 500);
                          }}
                        />
                        {this.state.checkingUsername && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2">
                            <i className="bx bx-loader-alt animate-spin text-gray-400"></i>
                          </span>
                        )}
                        {!this.state.checkingUsername && this.state.usernameAvailable === true && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-green-500">
                            <i className="bx bx-check-circle"></i>
                          </span>
                        )}
                        {!this.state.checkingUsername && this.state.usernameAvailable === false && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500">
                            <i className="bx bx-x-circle"></i>
                          </span>
                        )}
                      </div>
                      {this.state.usernameMessage && (
                        <p className={`text-xs mt-1 ${this.state.usernameAvailable ? 'text-green-600' : 'text-red-600'}`}>
                          {this.state.usernameMessage}
                        </p>
                      )}
                      {this.state.usernameRecommendations.length > 0 && (
                        <div className="mt-2 p-3 bg-blue-50 rounded-lg border border-blue-100">
                          <p className="text-xs text-blue-700 mb-2">
                            <i className="bx bx-bulb mr-1"></i>Rekomendasi username:
                          </p>
                          <div className="flex flex-wrap gap-2">
                            {this.state.usernameRecommendations.map((rec, idx) => (
                              <button
                                key={idx}
                                type="button"
                                onClick={() => this.selectRecommendedUsername(rec)}
                                className="px-3 py-1 text-xs bg-white border border-blue-200 rounded-full text-blue-700 hover:bg-blue-100 hover:border-blue-400 transition-all cursor-pointer"
                              >
                                {rec}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Email */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Email <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <i className="bx bx-envelope"></i>
                        </span>
                        <input
                          type="email"
                          className={`w-full pl-10 pr-10 py-2.5 rounded-xl border transition-all text-gray-800 ${this.state.emailAvailable === false ? 'border-red-400 focus:border-red-500 focus:ring-red-100' :
                            this.state.emailAvailable === true ? 'border-green-400 focus:border-green-500 focus:ring-green-100' :
                              'border-gray-200 focus:border-blue-500 focus:ring-blue-100'
                            } focus:ring-2`}
                          placeholder="Masukkan Email"
                          onChange={(e) => {
                            this.email(e);
                            const value = e.target.value;
                            clearTimeout(this.emailTimeout);
                            this.emailTimeout = setTimeout(() => this.checkEmailAvailability(value), 500);
                          }}
                        />
                        {this.state.checkingEmail && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2">
                            <i className="bx bx-loader-alt animate-spin text-gray-400"></i>
                          </span>
                        )}
                        {!this.state.checkingEmail && this.state.emailAvailable === true && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-green-500">
                            <i className="bx bx-check-circle"></i>
                          </span>
                        )}
                        {!this.state.checkingEmail && this.state.emailAvailable === false && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500">
                            <i className="bx bx-x-circle"></i>
                          </span>
                        )}
                      </div>
                      {this.state.emailMessage && (
                        <p className={`text-xs mt-1 ${this.state.emailAvailable ? 'text-green-600' : 'text-red-600'}`}>
                          {this.state.emailMessage}
                        </p>
                      )}
                    </div>

                    {/* Password with Show/Hide */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Password <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <i className="bx bx-lock"></i>
                        </span>
                        <input
                          type={this.state.showPasswordAdd ? "text" : "password"}
                          className="w-full pl-10 pr-12 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all text-gray-800"
                          placeholder="Masukkan Password"
                          onChange={(e) => {
                            this.password(e);
                            this.setState({ password_create: e.target.value });
                          }}
                        />
                        <button
                          type="button"
                          onClick={() => this.setState({ showPasswordAdd: !this.state.showPasswordAdd })}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                        >
                          <i className={`bx ${this.state.showPasswordAdd ? 'bx-hide' : 'bx-show'} text-lg`}></i>
                        </button>
                      </div>

                      {/* Password Strength Indicator */}
                      {this.state.password_create && (
                        <div className="mt-2">
                          <div className="flex gap-1 mb-1">
                            <div className={`h-1 flex-1 rounded-full ${this.state.password_create.length >= 1 ?
                              (this.state.password_create.length >= 8 && /[A-Z]/.test(this.state.password_create) && /[0-9]/.test(this.state.password_create) ? 'bg-green-500' :
                                this.state.password_create.length >= 6 ? 'bg-yellow-500' : 'bg-red-500')
                              : 'bg-gray-200'
                              }`}></div>
                            <div className={`h-1 flex-1 rounded-full ${this.state.password_create.length >= 6 ?
                              (this.state.password_create.length >= 8 && /[A-Z]/.test(this.state.password_create) && /[0-9]/.test(this.state.password_create) ? 'bg-green-500' : 'bg-yellow-500')
                              : 'bg-gray-200'
                              }`}></div>
                            <div className={`h-1 flex-1 rounded-full ${this.state.password_create.length >= 8 && /[A-Z]/.test(this.state.password_create) && /[0-9]/.test(this.state.password_create) ? 'bg-green-500' : 'bg-gray-200'
                              }`}></div>
                          </div>
                          <p className={`text-xs ${this.state.password_create.length >= 8 && /[A-Z]/.test(this.state.password_create) && /[0-9]/.test(this.state.password_create) ? 'text-green-600' :
                            this.state.password_create.length >= 6 ? 'text-yellow-600' : 'text-red-600'
                            }`}>
                            {this.state.password_create.length >= 8 && /[A-Z]/.test(this.state.password_create) && /[0-9]/.test(this.state.password_create) ?
                              '✓ Password Kuat' :
                              this.state.password_create.length >= 6 ?
                                'Password Sedang - Tambahkan huruf besar dan angka' :
                                'Password Lemah - Minimal 6 karakter'}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Info Box */}
                    <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mt-4">
                      <div className="flex items-start">
                        <i className="bx bx-info-circle text-blue-500 text-xl mr-3 mt-0.5"></i>
                        <div className="text-sm text-blue-700">
                          <p className="font-medium mb-1">Tips Password Kuat:</p>
                          <ul className="list-disc list-inside text-xs space-y-0.5 text-blue-600">
                            <li>Minimal 8 karakter</li>
                            <li>Kombinasi huruf besar & kecil</li>
                            <li>Sertakan angka</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer Actions */}
              <div className="px-6 py-4 bg-gray-50 border-t flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={this.hideModalTambah}
                  className="px-6 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-medium text-sm hover:bg-gray-100 transition-all"
                >
                  Batal
                </button>
                <button
                  type="submit"
                  disabled={this.state.simpleLoading}
                  className="px-8 py-2.5 rounded-xl text-white font-medium text-sm transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center btn-gradient-blue-indigo"
                  style={{ background: this.state.simpleLoading ? '#9ca3af' : undefined }}
                >
                  {this.state.simpleLoading ? (
                    <>
                      <i className="bx bx-loader-alt animate-spin mr-2"></i>
                      Menyimpan...
                    </>
                  ) : (
                    <>
                      <i className="bx bx-save mr-2"></i>
                      Simpan Guru
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </Modal>

        {/* Delete Progress Modal */}
        <DeleteProgressModal
          show={this.state.modal_delete_progress}
          onHide={this.hideDeleteProgressModal}
          steps={this.state.delete_steps}
          error={this.state.delete_error}
          onConfirm={this.executeDelete}
          onRetry={this.retryDelete}
          isDeleting={this.state.is_deleting}
          isComplete={this.state.delete_complete}
          userName={this.state.delete_user_name}
          userType="Guru"
        />

        {/* modal Edit */}
        <Modal
          show={this.state.modal_edit}
          onHide={this.hideModalEdit}
          size="lg"
          centered
          contentClassName="rounded-xl border-0 shadow-2xl overflow-hidden"
        >
          <div className="bg-white">
            <Modal.Header className="border-b border-gray-100 bg-gray-50/50 px-6 py-4">
              <div className="flex flex-col">
                <h4 className="text-xl font-bold text-gray-800">Edit Data Guru</h4>
                <p className="text-sm text-gray-500 mt-1">Perbarui informasi guru dengan teliti</p>
              </div>
            </Modal.Header>

            {this.state.loading_edit ? (
              <UserEditSkeleton />
            ) : (
              <Modal.Body className="p-6">
                <form onSubmit={this.update}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Left Column: Identity */}
                    <div className="space-y-4">
                      <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100/50">
                        <h5 className="text-sm font-bold text-blue-800 mb-4 flex items-center">
                          <i className='bx bxs-id-card mr-2'></i>
                          Identitas
                        </h5>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            No Pendaftaran / NIK
                          </label>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className='bx bx-id-card text-gray-400'></i>
                            </span>
                            <input
                              type="text"
                              className={`w-full pl-10 pr-10 py-2.5 rounded-lg border transition-all duration-200 bg-white text-gray-800 text-sm ${this.state.nikAvailable === true
                                ? 'border-green-400 focus:border-green-500 focus:ring-2 focus:ring-green-100'
                                : this.state.nikAvailable === false
                                  ? 'border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100'
                                  : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                }`}
                              placeholder="Contoh: 1234567890"
                              value={this.state.nik || ""}
                              onChange={(e) => {
                                this.nik(e);
                                this.checkNikAvailability(e.target.value);
                              }}
                            />
                            <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              {this.state.checkingNik && (
                                <i className='bx bx-loader-alt bx-spin text-blue-500'></i>
                              )}
                              {!this.state.checkingNik && this.state.nikAvailable === true && (
                                <i className='bx bx-check-circle text-green-500'></i>
                              )}
                              {!this.state.checkingNik && this.state.nikAvailable === false && (
                                <i className='bx bx-x-circle text-red-500'></i>
                              )}
                            </span>
                          </div>
                          {this.state.nikAvailable === false && this.state.nikMessage && (
                            <p className="text-xs text-red-500 mt-1">{this.state.nikMessage}</p>
                          )}
                        </div>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Nama Lengkap
                          </label>
                          <input
                            type="text"
                            className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm font-medium"
                            placeholder="Nama Lengkap Guru"
                            defaultValue={this.state.nama != "" ? this.state.nama : ""}
                            onChange={this.nama}
                          />
                        </div>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Jenis Kelamin
                          </label>
                          <div className="flex space-x-4 bg-white p-2 rounded-lg border border-gray-200">
                            <label className="flex items-center cursor-pointer p-2 rounded hover:bg-gray-50 flex-1 justify-center transition-colors">
                              <input
                                type="radio"
                                className="form-radio text-blue-600 h-4 w-4"
                                value="1"
                                name="jenis_kelamin_edit"
                                onChange={this.jenis_kelamin}
                                defaultChecked={this.state.jenis_kelamin == "1"}
                              />
                              <span className="ml-2 text-sm text-gray-700 font-medium">Laki-laki</span>
                            </label>
                            <div className="w-px bg-gray-200 h-6 self-center"></div>
                            <label className="flex items-center cursor-pointer p-2 rounded hover:bg-gray-50 flex-1 justify-center transition-colors">
                              <input
                                type="radio"
                                className="form-radio text-pink-500 h-4 w-4"
                                value="0"
                                name="jenis_kelamin_edit"
                                onChange={this.jenis_kelamin}
                                defaultChecked={this.state.jenis_kelamin == "0"}
                              />
                              <span className="ml-2 text-sm text-gray-700 font-medium">Perempuan</span>
                            </label>
                          </div>
                        </div>

                        <div>
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Tanggal Lahir
                          </label>
                          <input
                            type="date"
                            name="birthday"
                            className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                            defaultValue={this.state.tanggal_lahir != "" ? this.state.tanggal_lahir : ""}
                            onChange={this.tanggal_lahir}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Right Column: Account & Contact */}
                    <div className="space-y-4">
                      <div className="bg-yellow-50/50 p-4 rounded-xl border border-yellow-100/50 h-full">
                        <h5 className="text-sm font-bold text-yellow-800 mb-4 flex items-center">
                          <i className='bx bxs-lock-alt mr-2'></i>
                          Akun & Kontak
                        </h5>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Username
                          </label>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className='bx bx-user text-gray-400'></i>
                            </span>
                            <input
                              type="text"
                              className={`w-full pl-10 pr-10 py-2.5 rounded-lg border transition-all duration-200 bg-white text-gray-800 text-sm ${this.state.usernameAvailable === true
                                ? 'border-green-400 focus:border-green-500 focus:ring-2 focus:ring-green-100'
                                : this.state.usernameAvailable === false
                                  ? 'border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100'
                                  : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                }`}
                              placeholder="Username"
                              value={this.state.username || ""}
                              onChange={(e) => {
                                this.username(e);
                                this.checkUsernameAvailability(e.target.value);
                              }}
                            />
                            <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              {this.state.checkingUsername && (
                                <i className='bx bx-loader-alt bx-spin text-blue-500'></i>
                              )}
                              {!this.state.checkingUsername && this.state.usernameAvailable === true && (
                                <i className='bx bx-check-circle text-green-500'></i>
                              )}
                              {!this.state.checkingUsername && this.state.usernameAvailable === false && (
                                <i className='bx bx-x-circle text-red-500'></i>
                              )}
                            </span>
                          </div>
                          {this.state.usernameAvailable === false && this.state.usernameRecommendations.length > 0 && (
                            <div className="mt-2">
                              <p className="text-xs text-gray-500 mb-1">Username tidak tersedia. Coba salah satu:</p>
                              <div className="flex flex-wrap gap-1">
                                {this.state.usernameRecommendations.map((rec, idx) => (
                                  <button
                                    key={idx}
                                    type="button"
                                    className="text-xs px-2 py-1 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors border border-blue-200"
                                    onClick={() => this.selectUsernameRecommendation(rec)}
                                  >
                                    {rec}
                                  </button>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="mb-4">
                          <div className="flex items-center justify-between mb-2">
                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">
                              Email
                            </label>
                            {this.state.userStatus === 'Active' && (
                              <span className="text-[10px] px-2 py-0.5 bg-gray-100 text-gray-500 rounded-full font-medium flex items-center">
                                <i className='bx bx-lock-alt mr-1'></i> Terkunci
                              </span>
                            )}
                          </div>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className={`bx bx-envelope ${this.state.userStatus === 'Active' ? 'text-gray-300' : 'text-gray-400'}`}></i>
                            </span>
                            <input
                              type="email"
                              className={`w-full pl-10 pr-10 py-2.5 rounded-lg border transition-all duration-200 text-sm ${this.state.userStatus === 'Active'
                                ? 'border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
                                : this.state.emailAvailable === true
                                  ? 'border-green-400 focus:border-green-500 focus:ring-2 focus:ring-green-100 bg-white text-gray-800'
                                  : this.state.emailAvailable === false
                                    ? 'border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100 bg-white text-gray-800'
                                    : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 bg-white text-gray-800'
                                }`}
                              placeholder="email@sekolah.sch.id"
                              value={this.state.email || ""}
                              onChange={(e) => {
                                this.email(e);
                                if (this.state.userStatus !== 'Active') {
                                  this.checkEmailAvailability(e.target.value);
                                }
                              }}
                              disabled={this.state.userStatus === 'Active'}
                            />
                            {this.state.userStatus === 'Active' && (
                              <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <i className='bx bx-lock text-gray-300'></i>
                              </span>
                            )}
                            {this.state.userStatus !== 'Active' && this.state.checkingEmail && (
                              <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <i className='bx bx-loader-alt bx-spin text-blue-500'></i>
                              </span>
                            )}
                            {this.state.userStatus !== 'Active' && !this.state.checkingEmail && this.state.emailAvailable === true && (
                              <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <i className='bx bx-check-circle text-green-500'></i>
                              </span>
                            )}
                            {this.state.userStatus !== 'Active' && !this.state.checkingEmail && this.state.emailAvailable === false && (
                              <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <i className='bx bx-x-circle text-red-500'></i>
                              </span>
                            )}
                          </div>
                          {this.state.userStatus === 'Active' && (
                            <p className="text-[10px] text-gray-400 mt-1 italic">
                              Email tidak dapat diubah karena akun sudah aktif
                            </p>
                          )}
                          {this.state.userStatus !== 'Active' && this.state.emailAvailable === false && this.state.emailMessage && (
                            <p className="text-xs text-red-500 mt-1">{this.state.emailMessage}</p>
                          )}
                        </div>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            No Handphone / WA
                          </label>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className='bx bx-phone text-gray-400'></i>
                            </span>
                            <input
                              type="text"
                              className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                              placeholder="08xxxxxxxxxx"
                              defaultValue={this.state.no_telepon}
                              onChange={this.no_telepon}
                            />
                          </div>
                        </div>

                        <div className="pt-4 border-t border-yellow-200/50 mt-6">
                          <div className="flex items-center mb-2">
                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mr-2">
                              Ubah Password
                            </label>
                            <span className="text-[10px] px-2 py-0.5 bg-yellow-100 text-yellow-700 rounded-full font-medium">Opsional</span>
                          </div>
                          <p className="text-xs text-gray-400 mb-2 italic">Kosongkan jika tidak ingin mengubah password</p>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className='bx bx-key text-gray-400'></i>
                            </span>
                            <input
                              type={this.state.showPassword ? "text" : "password"}
                              className="w-full pl-10 pr-10 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                              placeholder="Password Baru"
                              defaultValue=""
                              onChange={(e) => {
                                this.password(e);
                                this.checkPasswordStrength(e.target.value);
                              }}
                            />
                            <button
                              type="button"
                              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
                              onClick={() => this.togglePasswordVisibility()}
                            >
                              {this.state.showPassword ? (
                                <i className="bx bx-hide text-lg"></i>
                              ) : (
                                <i className="bx bx-show text-lg"></i>
                              )}
                            </button>
                          </div>
                          {this.state.passwordStrengthText && (
                            <div className="mt-1 flex items-center justify-between">
                              <span className="text-[10px] text-gray-400">
                                Kekuatan Password:
                              </span>
                              <span
                                className={`text-[10px] font-bold ${this.state.passwordStrength}`}
                              >
                                {this.state.passwordStrengthText}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Hidden submit button to allow form submission on enter */}
                  <input type="submit" className="hidden" />
                </form>
              </Modal.Body>
            )}

            <Modal.Footer className="border-t border-gray-100 bg-gray-50/50 px-6 py-4 rounded-b-xl">
              <button
                className="px-6 py-2.5 rounded-lg text-gray-600 hover:text-gray-800 font-medium text-sm transition-colors hover:bg-gray-100 mr-2"
                onClick={this.hideModalEdit}
                type="button"
              >
                Batal
              </button>
              <button
                className={`px-8 py-2.5 rounded-lg text-white font-medium text-sm transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center ${this.state.simpleLoading || this.state.checkingUsername || this.state.checkingNik || this.state.checkingEmail
                  ? "cursor-not-allowed"
                  : this.state.usernameAvailable === false || this.state.nikAvailable === false || (this.state.userStatus !== 'Active' && this.state.emailAvailable === false)
                    ? "cursor-not-allowed"
                    : ""
                  }`}
                style={{
                  background: this.state.simpleLoading || this.state.checkingUsername || this.state.checkingNik || this.state.checkingEmail
                    ? "#9ca3af"
                    : this.state.usernameAvailable === false || this.state.nikAvailable === false || (this.state.userStatus !== 'Active' && this.state.emailAvailable === false)
                      ? "#f87171"
                      : "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)"
                }}
                onClick={this.update}
                type="button"
                disabled={this.state.simpleLoading || this.state.checkingUsername || this.state.usernameAvailable === false || this.state.checkingNik || this.state.nikAvailable === false || this.state.checkingEmail || (this.state.userStatus !== 'Active' && this.state.emailAvailable === false)}
              >
                {this.state.simpleLoading ? (
                  <>
                    <i className="bx bx-loader-alt bx-spin mr-2"></i>
                    Menyimpan...
                  </>
                ) : (
                  <>
                    <i className="bx bx-save mr-2"></i>
                    Simpan Perubahan
                  </>
                )}
              </button>
            </Modal.Footer>
          </div>
        </Modal>

        {/* modal detail */}
        <Modal
          size="lg"
          show={this.state.modal_detail}
          onHide={this.hideModalDetail}
        >
          {this.state.loading_detail ? (
            <UserDetailSkeleton />
          ) : (
            <Modal.Body className="">
              <div className="flex flex-col w-full">
                <div
                  className={`w-full rounded-lg bg-1 mb-10`}
                  style={{ height: "10rem" }}
                >
                  <div
                    className="overflow-hidden rounded-lg"
                    style={{ height: "10rem" }}
                  >
                    <img
                      className=""
                      src={
                        this.state.data_detail.foto_sampul
                          ? `https://static.schoolmedia.id/public/assets/socmed/GU/cover/${this.state.data_detail.foto_sampul}`
                          : `${conf.uri_frontend}assets/img/cover-unavailable.svg`
                      }
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div
                    className="flex flex-row px-4 pb-4 rounded-lg items-center w-full bg-transparent-grad relative"
                    style={{ bottom: "10rem", paddingTop: "6rem" }}
                  >
                    <img
                      className="rounded-full border-4 border-white shadow-xl"
                      style={{
                        width: "6rem",
                        height: "6rem",
                        objectFit: "cover",
                      }}
                      src={
                        this.state.data_detail.foto_profil
                          ? `${conf.uri_s3}/00-universal/${this.state.data_detail.website}/GU/${this.state.data_detail.foto_profil}`
                          : `${conf.uri_frontend}assets/img/profile-unavailable.png`
                      }
                    />
                    <h1 className="text-xl font-bold text-gray-800 ml-2">
                      {this.state.data_detail.nama
                        ? this.state.data_detail.nama
                        : "-"}
                    </h1>
                  </div>
                </div>
              </div>
              <Tabs
                defaultActiveKey="detail1"
                id="uncontrolled-tab-example"
                className="mt-4"
              >
                <Tab eventKey="detail1" title="Detail 1">
                  <div className="show-grid flex">
                    <div className="sm:w-full w-1/2">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Token
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.token
                            ? this.state.data_detail.token
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No Pendaftaran
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.kode_pendaftaran
                            ? this.state.data_detail.kode_pendaftaran
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Jenis Kelamin
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.jenis_kelamin != null
                            ? this.state.data_detail.jenis_kelamin != 1
                              ? "Perempuan"
                              : "Laki - laki"
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Tempat Lahir
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.tempat_lahir
                            ? this.state.data_detail.tempat_lahir
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Tanggal Lahir
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.tanggal_lahir
                            ? this.state.data_detail.tanggal_lahir
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/2">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Agama
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.agama
                            ? this.state.data_detail.agama
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. Handphone
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.no_handphone
                            ? this.state.data_detail.no_handphone
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Golongan Darah
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.golongan_darah
                            ? this.state.data_detail.golongan_darah
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Pendidikan Terakhir
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.pendidikan_terakhir
                            ? this.state.data_detail.pendidikan_terakhir
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Motto
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.motto
                            ? this.state.data_detail.motto
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="detail2" title="Detail 2">
                  <div className="show-grid flex">
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. KK
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.kk
                            ? this.state.data_detail.kk
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. NIK
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.nik
                            ? this.state.data_detail.nik
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. NPWP
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.npwp
                            ? this.state.data_detail.npwp
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. Paspor
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.paspor
                            ? this.state.data_detail.paspor
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Negara
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.negara
                            ? this.state.data_detail.negara
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-900 block text-sm">
                          Alamat Tinggal
                        </label>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Provinsi
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.provinsi_tinggal
                              ? this.state.data_detail.provinsi_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kabupaten / Kota
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kabupaten_tinggal
                              ? this.state.data_detail.kabupaten_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kecamatan
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kecamatan_tinggal
                              ? this.state.data_detail.kecamatan_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Desa
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.desa_tinggal
                              ? this.state.data_detail.desa_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kode Pos
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kode_pos__tinggal
                              ? this.state.data_detail.kode_pos__tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            RW / RT
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.rw_tinggal
                              ? this.state.data_detail.rw_tinggal
                              : "-"}{" "}
                            /
                            {this.state.data_detail.rt_tinggal
                              ? ` ${this.state.data_detail.rt_tinggal}`
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Alamat
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.alamat_tinggal
                              ? this.state.data_detail.alamat_tinggal
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-900 block text-sm">
                          Alamat Domisili
                        </label>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Provinsi
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.provinsi_domisili
                              ? this.state.data_detail.provinsi_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kabupaten / Kota
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kabupaten_domisili
                              ? this.state.data_detail.kabupaten_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kecamatan
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kecamatan_domisili
                              ? this.state.data_detail.kecamatan_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Desa
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.desa_domisili
                              ? this.state.data_detail.desa_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kode Pos
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kode_pos__domisili
                              ? this.state.data_detail.kode_pos__domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            RW / RT
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.rw_domisili
                              ? this.state.data_detail.rw_domisili
                              : "-"}{" "}
                            /
                            {this.state.data_detail.rt_domisili
                              ? ` ${this.state.data_detail.rt_domisili}`
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Alamat
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.alamat_domisili
                              ? this.state.data_detail.alamat_domisili
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </Modal.Body>
          )}

          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalDetail}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Cetak Modal */}
        <Modal
          size="lg"
          show={this.state.modal_cetak}
          onHide={this.hideModalCetak}
        >
          <Modal.Header>Cetak Guru</Modal.Header>
          <Modal.Body>
            <div className="flex justify-between items-center w-full px-2 py-2">
              <div className="w-1/2 flex items-center justify-start">
                <input
                  type="search"
                  className="w-2/3 pl-4 pr-1 py-1 rounded-full  border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm "
                  placeholder="Cari nama"
                  id="search"
                  onChange={(event) => {
                    this.setState(
                      {
                        queryToken: `&search=${event.target.value}
                                    &paginate=${this.state.mode_show_token}`,
                        searchToken: event.target.value,
                      },
                      function () {
                        this.dtt.loading();
                        this.dtt.fetchEntities(this.state.queryToken);
                      }
                    );
                  }}
                />
                <div className="ml-2 w-1/3 pl-3 pr-3 py-1 rounded-full flex justify-between items-center  border border-gray-500 focus:outline-none focus:shadow-outline  text-sm ">
                  <span className="text-sm text-gray-800">Pilih semua</span>
                  <input
                    type="checkbox"
                    className="select-all"
                    onChange={this.pilihSemua.bind(this)}
                  />
                </div>
              </div>
              <div className="w-1/2 text-right flex items-center">
                <div className="w-full ml-1 flex flex-wrap text-right items-center justify-end">
                  <div className="mr-0 flex text-right items-center">
                    <span className="text-sm  ml-auto text-gray-800 px-1 mb-2">
                      Tampilkan :{" "}
                    </span>
                    <button
                      onClick={this.showModeToken.bind(this, 10)}
                      className={`${this.state.mode_show_token == 10
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      10
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 50)}
                      className={`${this.state.mode_show_token == 50
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      50
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 100)}
                      className={`${this.state.mode_show_token == 100
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      100
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 200)}
                      className={`${this.state.mode_show_token == 200
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      200
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div id="cetakToken">
              {this.showTableToken()}
              {this.state.loading_saveprint ? (
                <button
                  className="btn-schoolmedia px-4 flex items-center rounded-full text-white mt-2 py-2 text-sm"
                  disabled={this.state.loading_saveprint == true ? true : false}
                >
                  <UserButtonLoading />
                </button>
              ) : (
                <input
                  type="button"
                  onClick={this.printToken.bind(this)}
                  className="btn-schoolmedia px-4 flex items-center rounded-full text-white mt-2 py-2 text-sm"
                  value="Simpan"
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalCetak}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Upload / Import */}
        <Modal
          size="lg"
          show={this.state.modal_import}
          onHide={this.hideModalImport}
        >
          <Modal.Header>Upload Data</Modal.Header>
          <Modal.Body>
            <div className="w-full mt-3 flex flex-row items-center">
              <label className="mb-2 ml-2 text-gray-800 block text-sm mt-3 mr-2">
                Download template excelnya dulu sebelum upload data
              </label>
              <a
                href={`${conf.uri_s3}/02-user-management/format/new-format-input-guru.xlsx`}
                download
              >
                <button className="btn-default flex text-xs px-4 py-2 mr-1 rounded-full items-center">
                  Download
                  <i className="bx bx-download ml-1"></i>
                </button>
              </a>
              <a
                href="https://help.schoolmedia.id/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="btn-default flex text-xs px-4 py-2 mr-1 rounded-full items-center">
                  Tutorial Upload
                  <i className="bx bx-info-circle ml-1"></i>
                </button>
              </a>
            </div>
            <form onSubmit={this.import}>
              <div className="w-full mt-3">
                <label className="mb-2 ml-2 text-gray-800 block text-sm mt-3">
                  File Excel
                </label>
                <input
                  type="file"
                  className="w-full pl-4 pr-4 my-0 py-2 rounded-full  border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 "
                  onChange={this.import_file}
                />
              </div>
              <input
                type="submit"
                className={
                  this.state.simpleLoading
                    ? "btn-disabled px-4 flex items-center rounded-full py-2 mt-2 text-sm"
                    : "btn-schoolmedia px-4 flex items-center rounded-full text-white py-2 mt-2 text-sm"
                }
                value={this.state.simpleLoading ? "Tunggu..." : "Simpan"}
                disabled={this.state.simpleLoading ? true : false}
              />
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalImport}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Preview Import */}
        <Modal
          size="lg"
          show={this.state.modal_preview_import}
          onHide={this.hideModalPrevImport}
        >
          <Modal.Header>Preview Import</Modal.Header>
          <Modal.Body>
            <form onSubmit={this.simpanImport}>
              <div className="table-responsive">
                <table className="table table-bordered font-thin text-sm">
                  <thead className="text-center">
                    <th>KODE PENDAFTARAN</th>
                    <th>NAMA</th>
                    <th>INISIAL</th>
                    <th>JENIS KELAMIN</th>
                    <th>TANGGAL LAHIR</th>
                    <th>NO HANDPHONE</th>
                    <th>USERNAME</th>
                    <th>EMAIL</th>
                    <th>PASSWORD</th>
                    <th>NAMA FILE FOTO PROFIL</th>
                  </thead>
                  <tbody>
                    {this.state.data_preview.map((person, index) => (
                      <tr className={person.duplicated ? 'table-danger' : ''} key={index}>
                        <td>
                          <div className="text-sm">
                            {person.kode_pendaftaran}
                          </div>
                        </td>
                        <td>
                          <div className="text-sm">{person.nama}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.inisial_nama}</div>
                        </td>
                        <td>
                          <div className="text-sm">
                            {
                              this.state.jenis_kelamin_text[
                              person.jenis_kelamin
                              ]
                            }
                          </div>
                        </td>
                        <td>
                          <div className="text-sm">{person.tanggal_lahir}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.no_handphone}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.username}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.email}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.password}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.foto_profil}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <input
                type="submit"
                className={
                  this.state.simpleLoading
                    ? "btn-disabled px-4 flex items-center rounded-full py-2 mt-2 text-sm"
                    : "btn-schoolmedia px-4 flex items-center rounded-full text-white py-2 mt-2 text-sm"
                }
                value={this.state.simpleLoading ? "Tunggu..." : "Simpan"}
                disabled={this.state.simpleLoading ? true : false}
              />
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalPrevImport}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-6 mt-4 sm-container">
          {this.state.institusi_id_select != "" ? (
            <>
              <div className="flex flex-col lg:flex-row lg:items-center gap-4 pb-4">
                {/* Search Input */}
                <div className="relative flex-1">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400">
                    <i className="bx bx-search text-xl"></i>
                  </span>
                  <input
                    type="search"
                    id="search"
                    className="w-full pl-10 pr-4 py-2 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-gray-50/50 text-gray-800 text-sm focus:bg-white focus:outline-none"
                    placeholder="Cari kode pendaftaran, nama, username, token..."
                    onChange={this.searchText}
                  />
                </div>

                {/* Filter and Status Controls */}
                <div className="flex flex-wrap items-center gap-3">
                  {/* Status Dropdown */}
                  <div className="w-52" style={{ minWidth: "180px" }}>
                    <Select
                      styles={selectStyles}
                      className="text-sm"
                      placeholder="Pilih Status"
                      isClearable
                      isDisabled={this.state.disabledFilter}
                      defaultValue={
                        this.state.selectStatus != ""
                          ? {
                            value: this.state.selectStatus,
                            label: this.state.selectStatus,
                          }
                          : null
                      }
                      options={[
                        { value: "Active", label: "Active" },
                        { value: "Pending", label: "Pending" },
                      ]}
                      onChange={(e) => {
                        this.changeStatus(e);
                      }}
                    />
                  </div>

                  {/* Total Data Count Badge */}
                  <div className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 border border-gray-150 rounded-xl text-xs font-semibold text-gray-600">
                    <span>Total data:</span>
                    <span className="text-gray-900 bg-gray-200/50 px-2 py-0.5 rounded-md font-bold">
                      {this.state.totalUser != "" ? (
                        this.state.totalUser
                      ) : (
                        <i className="bx bx-loader-alt bx-spin"></i>
                      )}
                    </span>
                  </div>
                </div>

                {/* Show limit page buttons */}
                <div className="flex items-center gap-2 lg:ml-auto border-t lg:border-t-0 pt-3 lg:pt-0">
                  <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider mr-1">
                    Tampilkan:
                  </span>
                  <div className="inline-flex rounded-xl p-1 bg-gray-100/80">
                    {[10, 50, 100, 200].map((limit) => (
                      <button
                        key={limit}
                        onClick={this.showMode.bind(this, limit)}
                        className={`px-3 py-1 rounded-lg text-xs font-semibold transition-all duration-200 ${
                          this.state.mode_show === limit
                            ? "bg-white text-blue-600 shadow-sm font-bold"
                            : "text-gray-600 hover:text-gray-900"
                        }`}
                      >
                        {this.state.loading_showmode === limit ? (
                          <div className="w-3 h-3 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                          limit
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="w-full flex justify-between gap-4 py-2">
              <div className="w-1/2 flex gap-4">
                <Skeleton width={180} height={38} className="rounded-xl" />
                <Skeleton width={120} height={38} className="rounded-xl" />
              </div>
              <div className="w-1/2 flex justify-end gap-4">
                <Skeleton width={180} height={38} className="rounded-xl" />
              </div>
            </div>
          )}

          <div className="mt-4 overflow-hidden border border-gray-100 rounded-2xl bg-gray-50/20 px-2 py-1">
            <DataTable
              ref={(dt) => {
                this.dt = dt;
              }}
              action={{
                jenis_kelamin: (col, data) => {
                  var jekel = "";
                  if (col.jenis_kelamin == 1) {
                    jekel = "Laki - Laki";
                  }

                  if (col.jenis_kelamin == 0) {
                    jekel = "Perempuan";
                  }

                  if (col.jenis_kelamin == null) {
                    jekel = "Belum diketahui";
                  }
                  return <p className="text-sm">{jekel}</p>;
                },

                inisial: (col, data) => {
                  var inisial = "";
                  var potong = "";
                  var potong2 = "";
                  var potong4 = "";
                  var potong5 = "";
                  if (col.inisial !== null) {
                    inisial = col.inisial;
                  } else if (col.nama !== null) {
                    potong = col.nama.substr(0, 3);
                    potong2 = col.nama.substr(0, 2);
                    potong4 = col.nama.substr(0, 4);
                    potong5 = col.nama.substr(0, 5);
                    if (potong == "Dr.") {
                      potong = col.nama.substr(4);
                      inisial = potong.substr(0, 3);
                    } else if (potong4 == "Drs.") {
                      potong = col.nama.substr(5);
                      inisial = potong.substr(0, 3);
                    } else if (potong == "Ir.") {
                      potong = col.nama.substr(4);
                      inisial = potong.substr(0, 3);
                    } else if (potong5 == "Prof.") {
                      potong = col.nama.substr(6);
                      inisial = potong.substr(0, 3);
                    } else if (potong2 == "H.") {
                      potong = col.nama.substr(3);
                      inisial = potong.substr(0, 3);
                    } else if (potong == "Hj.") {
                      potong = col.nama.substr(4);
                      inisial = potong.substr(0, 3);
                    } else {
                      inisial = potong.substr(0, 3);
                    }
                  }
                  return <p className="text-sm uppercase">{inisial}</p>;
                },

                created_at: (col, data) => {
                  if (col.created_at !== null) {
                    var date = "";
                    var month = "";
                    var year = "";
                    date = col.created_at.substr(8, 2);
                    month = col.created_at.substr(5, 2);
                    year = col.created_at.substr(0, 4);

                    return (
                      <p className="text-sm">
                        {date + "-" + month + "-" + year}
                      </p>
                    );
                  } else {
                    return <p className="text-sm">Tidak Diketahui</p>;
                  }
                },

                status: (col, data) => {
                  var statusUsr = "";
                  var tooltip = "";
                  var warna = "";
                  var ikon = "";
                  var width = "";

                  if (col.status === "Active") {
                    statusUsr = "Aktif";
                    tooltip = "User sudah teraktivasi";
                    warna = "bg-green-600";
                    ikon = "bx-check";
                    width = "w-16";
                  } else if (col.status === "Non-Active") {
                    statusUsr = "Non-Aktif";
                    tooltip = "User telah dinon-aktifkan";
                    warna = "bg-red-600";
                    ikon = "bx-x";
                    width = "w-auto";
                  } else {
                    statusUsr = "Pending";
                    tooltip =
                      "User belum aktivasi di SSO dan klik link konfirmasi di email";
                    warna = "bg-gray-600";
                    ikon = "bx-error";
                    width = "w-20";
                  }
                  return (
                    <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
                      <div
                        className={`py-1 ${width} px-1 ${warna} text-white text-xs rounded-full flex cursor`}
                      >
                        <i
                          className={`bx ${ikon} text-white font-bold text-sm mx-1`}
                        ></i>
                        {statusUsr}
                      </div>
                    </OverlayTrigger>
                  );
                },

                token: (col, data) => {
                  var tokenNull = (
                    <div
                      id={"token" + data.id}
                      className="text-sm text-token hidden-comp"
                    ></div>
                  );
                  var buttonToken = (
                    <div>
                      <button
                        onClick={this.generate_token.bind(this, data.id)}
                        id={"myButton" + data.id}
                        className="btn-token block hidden-comp font-medium btn-default text-gray-700 px-4 py-2 mr-1 rounded-full text-sm"
                        disabled={
                          this.state.loading_token === data.id ? true : false
                        }
                      >
                        {this.state.loading_token === data.id ? (
                          <UserButtonLoading color="text-gray-800" />
                        ) : (
                          "Token"
                        )}
                      </button>
                      <div>{col.token === null ? tokenNull : null}</div>
                    </div>
                  );
                  var token = (
                    <div className="text-sm" id="t">
                      {col.token}
                    </div>
                  );
                  if (col.token === null) {
                    return buttonToken;
                  } else {
                    return token;
                  }
                },

                emaila: (col, data) => {
                  if (data?.email == null || data?.email == "") {
                    var value = "-";
                  } else {
                    var value = data.email;
                  }
                  return (
                    <>
                      <small className="text-small">{value}</small>
                    </>
                  );
                },
                usernamea: (col, data) => {
                  if (data?.username == null || data?.username == "") {
                    var value = "-";
                  } else {
                    var value = data.username;
                  }
                  return (
                    <>
                      <small className="text-small">{value}</small>
                    </>
                  );
                },
                aksi: (col, data) => {
                  return (
                    <div className="text-gray-700 px-4 py-1 flex items-center">
                      <button
                        onClick={this.showModalDetail.bind(this, data.id)}
                        className="btn-blue text-lg text-white py-1 px-2 rounded-full font-medium mr-1"
                      >
                        <i className="bx bxs-user-detail"></i>
                      </button>
                      <button
                        onClick={this.showModalEdit.bind(this, data.id)}
                        className="btn-yellow text-lg text-white py-1 px-2 rounded-full font-medium mr-1"
                      >
                        <i className="bx bxs-edit-alt"></i>
                      </button>
                      <button
                        onClick={this.delete.bind(this, data.id, data.nama)}
                        className="btn-red text-lg text-white py-1 px-2 rounded-full font-medium"
                      >
                        <i className="bx bx-trash"></i>
                      </button>
                      {this.state.loading_check == false ? (
                        <input
                          type="checkbox"
                          name="check_data[]"
                          id={data.id}
                          value={data.id}
                          onChange={this.selectOne}
                          className="select-checkbox ml-2"
                          defaultChecked={this.state.checkAll}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  );
                },
              }}
              url={this.state.url_table + this.state.institusi_id_select}
              columns={[
                {
                  index: "no_index",
                  label: "No",
                },
                {
                  index: "kode_pendaftaran",
                  label: "Kode Pendaftaran",
                },
                {
                  index: "nama",
                  label: "NAMA",
                },
                {
                  index: "inisial",
                  label: "INISIAL",
                },
                {
                  index: "usernamea",
                  label: "USERNAME",
                },
                {
                  index: "emaila",
                  label: "EMAIL",
                },
                {
                  index: "jenis_kelamin",
                  label: "JENIS KELAMIN",
                },
                {
                  index: "created_at",
                  label: "TANGGAL PENDAFTARAN",
                },
                {
                  index: "status",
                  label: "STATUS",
                },
                {
                  index: "token",
                  label: "TOKEN",
                },
                {
                  index: "aksi",
                  label: "AKSI",
                },
              ]}
            />
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-4 mt-4 sm-container">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-2">
            <div className="flex items-center gap-2 text-gray-500">
              <i className="bx bx-checkbox-checked text-2xl text-blue-500"></i>
              <span className="text-sm font-medium">Tandai beberapa guru di tabel untuk melakukan aksi massal</span>
            </div>
            
            <div className="flex flex-wrap items-center gap-2 sm:justify-end">
              {this.state.checkAll === false ? (
                <button
                  className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  onClick={this.checkAll}
                >
                  <i className="bx bx-check-square text-lg"></i>
                  <span>Pilih Semua</span>
                </button>
              ) : (
                <button
                  className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-blue-600 bg-blue-50 border border-blue-150 rounded-xl hover:bg-blue-100 transition-all duration-200 shadow-sm"
                  onClick={this.unCheckAll}
                >
                  <i className="bx bx-x-square text-lg"></i>
                  <span>Batal Pilih</span>
                </button>
              )}

              <button
                onClick={this.deleteMulti}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-rose-600 bg-rose-50 border border-rose-100 rounded-xl hover:bg-rose-100 hover:text-rose-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_delete ? (
                  <UserButtonLoading color="text-rose-600" />
                ) : (
                  <>
                    <i className="bx bx-trash text-lg"></i>
                    <span>Hapus</span>
                  </>
                )}
              </button>

              <button
                onClick={this.sendMailActivation}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-blue-600 bg-blue-50 border border-blue-100 rounded-xl hover:bg-blue-100 hover:text-blue-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_mail ? (
                  <UserButtonLoading color="text-blue-600" />
                ) : (
                  <>
                    <i className="bx bx-envelope text-lg"></i>
                    <span>Send Email</span>
                  </>
                )}
              </button>

              <button
                onClick={this.sendWAActivation}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-emerald-600 bg-emerald-50 border border-emerald-100 rounded-xl hover:bg-emerald-100 hover:text-emerald-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_mail ? (
                  <UserButtonLoading color="text-emerald-600" />
                ) : (
                  <>
                    <i className="bx bxl-whatsapp text-lg"></i>
                    <span>Send WA</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Excel Import Wizard - Premium 4-Step Import */}
        <ExcelImportWizard
          show={this.state.modal_excel_wizard}
          onClose={() => this.setState({ modal_excel_wizard: false })}
          type="GU"
          institusiId={this.state.institusi_id_select}
          title="Import Data Guru"
          templateUrl={`${conf.uri_s3}/02-user-management/format/new-format-input-guru.xlsx`}
          onImportComplete={(result) => {
            // Refresh table on import complete
            this.dt.fetchEntities(
              `&paginate=${this.state.mode_show}&query=${this.state.query}`
            );
            this.showCount();
          }}
        />
      </div>
    );
  }
}